import { LocaleKeys } from './translation-types'

export const fr: Record<LocaleKeys, string> = {
  //download documents ----------------------------------------------------------------
  'downloadDocuments.loading': 'Génération du fichier en cours...',

  // enrollment ----------------------------------------------------------------
  'enrollment.notFound': 'Enfant non trouvé',
  'enrollment.profile.pdf.title': 'Aperçu du document',
  'enrollment.profile.pdf.label': "Bulletin d'inscription sheet",
  'enrollment.profile.pdf.close': 'Fermer',
  'enrollment.profile.pdf.unlock': 'Débloquer',
  'enrollment.profile.pdf.validate': 'Valider',

  //file ----------------------------------------------------------------
  'file.caption': 'Légende',
  'file.upload.placeholder': 'Glisser-déposer ou parcourir',
  'file.upload.label': 'Upload fichier',

  // Bank Payment Status enum ----------------------------------------------------------------
  'center.ol.payment.status.enum.CREATED': 'Créé',
  'center.ol.payment.status.enum.EXPORTED': 'Export banque',
  'center.ol.payment.status.enum.VALIDATED': 'Validé',

  //gender enum ----------------------------------------------------------------
  'gender.enum.male': 'Masculin',
  'gender.enum.female': 'Féminin',

  //position status enum ----------------------------------------------------------------
  'position.status.fullTime': 'Temps plein',
  'position.status.partTime': 'Temps partiel',

  //Conveyance type enum ----------------------------------------------------------------
  'conveyance.type.walk': 'Marche',
  'conveyance.type.bus': 'Bus',
  'conveyance.type.train': 'Train',

  //report status enum ----------------------------------------------------------------
  'report.status.enum.DRAFT': 'Brouillon',
  'report.status.enum.SENT': 'Envoyé',
  'report.status.enum.VALIDATED': 'Validé',

  //Language enum ----------------------------------------------------------------
  'language.enum.english': 'Anglais',
  'language.enum.german': 'Allemand',
  'language.enum.spanish': 'Espagnol',

  //Translation locale ----------------------------------------------------------------
  'translation.locale.FR': 'Français',
  'translation.locale.EN': 'Anglais',
  'translation.locale.DE': 'Allemand',
  'translation.locale.ES': 'Espagnol',
  'translation.value.required': 'Ce champ est requis',

  //Document status enum ----------------------------------------------------------------
  'document.status.enum.VERIFIED': 'Vérifié',
  'document.status.enum.REFUSED': 'Refusé',
  'document.status.enum.PENDING': 'En attente',
  'document.status.enum.RECEIVED': 'Reçu',

  //staff Document Type Enum Mapping ----------------------------------------------------------------
  'staff.document.type.enum.diploma': 'Diplôme',
  'staff.document.type.enum.paySlip': 'Bulletin de paie',
  'staff.document.type.enum.eta': 'ETA',
  'staff.document.type.enum.criminalRecord': 'Casier judiciaire',
  'staff.document.type.enum.idFile': 'Pièce d’identité',

  //staff qualification enum mapping ----------------------------------------------------------------
  'staff.qualification.enum.ACTIVITY_LEADER': 'Activity Leader',
  'staff.qualification.enum.PROVINCE_CONVEYOR': 'Convoyeur Province',
  'staff.qualification.enum.BAFA_ANIMATOR': 'Animateur Collège',
  'staff.qualification.enum.COORDINATING_PROFESSOR': 'Professeur coordinateur',
  'staff.qualification.enum.DEPUTY': 'Adjoint',
  'staff.qualification.enum.DIRECTOR': 'Directeur',
  'staff.qualification.enum.FAC_PARIS': 'FAC Paris',
  'staff.qualification.enum.FAC_TERRAIN': 'FAC Terrain',
  'staff.qualification.enum.PROFESSOR_ENGLISH_COLLEGE': "Professeur d'anglais collège",
  'staff.qualification.enum.FH_ANIMATOR': 'Animateur FH',
  'staff.qualification.enum.FOREIGN_CONVEYOR': 'Convoyeur Étranger',
  'staff.qualification.enum.PROFESSOR_ENGLISH': 'Professeur d’anglais FH',
  'staff.qualification.enum.PROFESSOR_ENGLISH_PREPA_SUP': 'Professeur d’anglais prépa sup',
  'staff.qualification.enum.PROFESSOR_GERMAN': 'Professeur d’allemand',
  'staff.qualification.enum.PROFESSOR_SPANISH': 'Professeur d’espagnol',
  'staff.qualification.enum.REFERENT': 'Référent',
  'staff.qualification.enum.SANITARY_ASSISTANT_ANIMATOR': 'Animateur assistant sanitaire',
  'staff.qualification.enum.STATION_ASSISTANT': 'Assistant Gare',
  'staff.qualification.enum.SWIMMING_MONITOR_ANIMATOR': 'Animateur surveillant de baignade',
  'staff.qualification.enum.TEFL': 'TEFL',
  'staff.qualification.enum.THEME_BASKETBALL_COACH': 'Thème - Basketball Coach',
  'staff.qualification.enum.THEME_BASKETBALL_TRAINER': 'Thème - Entraineur de basket',
  'staff.qualification.enum.THEME_CHESS_COACH': 'Thème - Chess Coach',
  'staff.qualification.enum.THEME_CHESS_TRAINER': 'Thème - Entraineur de jeu d’échecs',
  'staff.qualification.enum.THEME_DANCE_COACH': 'Thème - Dance Coach',
  'staff.qualification.enum.THEME_DANCE_PROFESSOR': 'Thème - Professeur de Danse',
  'staff.qualification.enum.THEME_DRAMA_COACH': 'Thème - Drama Coach',
  'staff.qualification.enum.THEME_FOOTBALL_COACH': 'Thème - Football Coach',
  'staff.qualification.enum.THEME_FOOTBALL_TRAINER': 'Thème - Entraineur de foot',
  'staff.qualification.enum.THEME_MANGA_COACH': 'Thème - Manga Coach',
  'staff.qualification.enum.THEME_MANGA_PROFESSOR': 'Thème - Professeur de Manga',
  'staff.qualification.enum.THEME_MUSIC_COACH': 'Thème - Music Coach',
  'staff.qualification.enum.THEME_MUSIC_PROFESSOR': 'Thème - Professeur de Musique',
  'staff.qualification.enum.THEME_TENNIS_COACH': 'Thème - Tennis Coach',
  'staff.qualification.enum.THEME_TENNIS_TRAINER': 'Thème - Entraineur de tennis',
  'staff.qualification.enum.THEME_THEATER_PROFESSOR': 'Thème - Professeur de Théâtre',
  'staff.qualification.enum.THEME_FOOTBALL_COACH_DAILY': 'Thème - Football Coach Daily',
  'staff.qualification.enum.THEME_BASKETBALL_COACH_DAILY': 'Thème - Basketball Coach Daily',
  'staff.qualification.enum.THEME_TENNIS_COACH_DAILY': 'Thème - Tennis Coach Daily',
  'staff.qualification.enum.THEME_CHESS_COACH_DAILY': 'Thème - Chess Coach Daily',
  'staff.qualification.enum.THEME_MANGA_COACH_DAILY': 'Thème - Manga Coach Daily',
  'staff.qualification.enum.THEME_DANCE_COACH_DAILY': 'Thème - Dance Coach Daily',
  'staff.qualification.enum.THEME_DRAMA_COACH_DAILY': 'Thème - Drama Coach Daily',
  'staff.qualification.enum.THEME_MUSIC_COACH_DAILY': 'Thème - Music Coach Daily',

  //ol staff qualification enum mapping (foreign OL spaces wording) ----------------------------------------------------------------
  'ol.staff.qualification.enum.ACTIVITY_LEADER': 'Activity Leader',
  'ol.staff.qualification.enum.PROVINCE_CONVEYOR': 'Convoyeur Province',
  'ol.staff.qualification.enum.BAFA_ANIMATOR': 'Animateur Collège',
  'ol.staff.qualification.enum.COORDINATING_PROFESSOR': 'Professeur coordinateur',
  'ol.staff.qualification.enum.DEPUTY': 'Adjoint',
  'ol.staff.qualification.enum.DIRECTOR': 'Directeur',
  'ol.staff.qualification.enum.FAC_PARIS': 'FAC Paris',
  'ol.staff.qualification.enum.FAC_TERRAIN': 'FAC Terrain',
  'ol.staff.qualification.enum.PROFESSOR_ENGLISH_COLLEGE': "Professeur d'anglais collège",
  'ol.staff.qualification.enum.FH_ANIMATOR': 'Animateur FH',
  'ol.staff.qualification.enum.FOREIGN_CONVEYOR': 'Convoyeur Étranger',
  'ol.staff.qualification.enum.PROFESSOR_ENGLISH': 'Professeur d’anglais FH',
  'ol.staff.qualification.enum.PROFESSOR_ENGLISH_PREPA_SUP': 'Professeur d’anglais prépa sup',
  'ol.staff.qualification.enum.PROFESSOR_GERMAN': 'Professeur d’allemand',
  'ol.staff.qualification.enum.PROFESSOR_SPANISH': 'Professeur d’espagnol',
  'ol.staff.qualification.enum.REFERENT': 'Référent',
  'ol.staff.qualification.enum.SANITARY_ASSISTANT_ANIMATOR': 'Animateur assistant sanitaire',
  'ol.staff.qualification.enum.STATION_ASSISTANT': 'Assistant Gare',
  'ol.staff.qualification.enum.SWIMMING_MONITOR_ANIMATOR': 'Animateur surveillant de baignade',
  'ol.staff.qualification.enum.TEFL': 'TEFL',
  'ol.staff.qualification.enum.THEME_BASKETBALL_COACH': 'Thème - Basketball Coach',
  'ol.staff.qualification.enum.THEME_BASKETBALL_TRAINER': 'Thème - Entraineur de basket',
  'ol.staff.qualification.enum.THEME_CHESS_COACH': 'Thème - Chess Coach',
  'ol.staff.qualification.enum.THEME_CHESS_TRAINER': 'Thème - Entraineur de jeu d’échecs',
  'ol.staff.qualification.enum.THEME_DANCE_COACH': 'Thème - Dance Coach',
  'ol.staff.qualification.enum.THEME_DANCE_PROFESSOR': 'Thème - Professeur de Danse',
  'ol.staff.qualification.enum.THEME_DRAMA_COACH': 'Thème - Drama Coach',
  'ol.staff.qualification.enum.THEME_FOOTBALL_COACH': 'Thème - Football Coach',
  'ol.staff.qualification.enum.THEME_FOOTBALL_TRAINER': 'Thème - Entraineur de foot',
  'ol.staff.qualification.enum.THEME_MANGA_COACH': 'Thème - Manga Coach',
  'ol.staff.qualification.enum.THEME_MANGA_PROFESSOR': 'Thème - Professeur de Manga',
  'ol.staff.qualification.enum.THEME_MUSIC_COACH': 'Thème - Music Coach',
  'ol.staff.qualification.enum.THEME_MUSIC_PROFESSOR': 'Thème - Professeur de Musique',
  'ol.staff.qualification.enum.THEME_TENNIS_COACH': 'Thème - Tennis Coach',
  'ol.staff.qualification.enum.THEME_TENNIS_TRAINER': 'Thème - Entraineur de tennis',
  'ol.staff.qualification.enum.THEME_THEATER_PROFESSOR': 'Thème - Professeur de Théâtre',
  'ol.staff.qualification.enum.THEME_FOOTBALL_COACH_DAILY': 'Thème - Football Coach Daily',
  'ol.staff.qualification.enum.THEME_BASKETBALL_COACH_DAILY': 'Thème - Basketball Coach Daily',
  'ol.staff.qualification.enum.THEME_TENNIS_COACH_DAILY': 'Thème - Tennis Coach Daily',
  'ol.staff.qualification.enum.THEME_CHESS_COACH_DAILY': 'Thème - Chess Coach Daily',
  'ol.staff.qualification.enum.THEME_MANGA_COACH_DAILY': 'Thème - Manga Coach Daily',
  'ol.staff.qualification.enum.THEME_DANCE_COACH_DAILY': 'Thème - Dance Coach Daily',
  'ol.staff.qualification.enum.THEME_DRAMA_COACH_DAILY': 'Thème - Drama Coach Daily',
  'ol.staff.qualification.enum.THEME_MUSIC_COACH_DAILY': 'Thème - Music Coach Daily',

  //staff position enum mapping ----------------------------------------------------------------
  'staff.position.enum.TEACHER': 'Professeur',
  'staff.position.enum.ANIMATOR': 'Animateur',
  'staff.position.enum.AAT': 'AAT',

  //ol staff position enum mapping (foreign OL spaces wording) ----------------------------------------------------------------
  'ol.staff.position.enum.TEACHER': 'Professeur',
  'ol.staff.position.enum.ANIMATOR': 'Animateur',
  'ol.staff.position.enum.AAT': 'AAT',

  //school Level Taught Enum Mapping ----------------------------------------------------------------
  'school.level.taught.enum.PRIMARY': 'Primaire',
  'school.level.taught.enum.COLLEGE': 'Collège',
  'school.level.taught.enum.HIGH_SCHOOL': 'Lycée',
  'school.level.taught.enum.BTS_IUT_UNIVERSITY': 'BTS/IUT/Université',
  'school.level.taught.enum.PREPARATORY_CLASSES': 'Classes préparatoires',
  'school.level.taught.enum.OTHER': 'Autre',

  //center status enum mapping ----------------------------------------------------------------
  'center.status.enum.OPEN': 'Ouvert',
  'center.status.enum.OPEN.label': "A compléter par l'OL",
  'center.status.enum.OPEN.activity.label': "A compléter par l'OL",

  'center.status.enum.SENT_TO_LEC': 'Envoyé à LEC',
  'center.status.enum.SENT_TO_LEC.label': 'Envoyé à LEC',
  'center.status.enum.SENT_TO_LEC.activity.label': 'Pas encore validé par LEC',

  'center.status.enum.VALIDATED': 'Validé',
  'center.status.enum.VALIDATED.label': 'Validé',
  'center.status.enum.VALIDATED.activity.label': 'Validé par LEC',

  'center.status.enum.OPEN.travel.expense.label': 'A compléter',
  'center.status.enum.SENT_TO_LEC.travel.expense.label': 'Envoyé à LEC',
  'center.status.enum.VALIDATED.travel.expense.label': 'Validé par LEC',

  // Diploma Enum ----------------------------------------------------------------
  'diploma.enum.BAFA': 'BAFA',
  'diploma.enum.BAFD': 'BAFD',
  'diploma.enum.PSC1_AFPS': 'PSC1_AFPS',
  'diploma.enum.SB': 'SB',
  'diploma.enum.AGREGATION': 'Agrégation',
  'diploma.enum.CAPES': 'CAPES',
  'diploma.enum.PLP2': 'PLP2',
  'diploma.enum.MASTER': 'Master',
  'diploma.enum.LICENCE': 'Licence',
  'diploma.enum.TEFL_CELTA': 'TEFL CELTA',
  'diploma.enum.OTHER': 'Autre',

  //marital Status Enum Mapping ----------------------------------------------------------------
  'marital.status.enum.SINGLE': 'Célibataire',
  'marital.status.enum.COHABITATION': 'En concubinage',
  'marital.status.enum.PACS': 'Pacsé(e)',
  'marital.status.enum.MARRIED': 'Marié(e)',
  'marital.status.enum.DIVORCED': 'Divorcé(e)',
  'marital.status.enum.WIDOW': 'Veuf(ve)',

  //accomodation Type Enum Mapping ----------------------------------------------------------------
  'accomodation.type.enum.FLAT': 'Appartement',
  'accomodation.type.enum.HOUSE': 'Maison',
  'accomodation.type.enum.GARDEN': 'Jardin',
  'accomodation.type.enum.NO_GARDEN': 'Pas de jardin',

  //product type enum mapping ----------------------------------------------------------------
  'product.type.enum.NORMAL.title': 'Normale',
  'product.type.enum.NORMAL.label': 'Normale',
  'product.type.enum.ONE_TO_ONE.title': 'OTO',
  'product.type.enum.ONE_TO_ONE.label': 'One to One accompagné',
  'product.type.enum.ONE_TO_ONE_INDIVIDUAL.title': 'OTO Indiv',
  'product.type.enum.ONE_TO_ONE_INDIVIDUAL.label': 'One to One individuel',
  'product.type.enum.CLUB_FOUR.title': 'Club 4',
  'product.type.enum.CLUB_FOUR.label': 'Club 4',

  'product.number.of.hours.per.week': '{{hours}}h de cours / sem',

  //Leader Free Rate Enum Mapping ----------------------------------------------------------------
  'leader.free.rate.enum.ALL_LEADERS_FREE': 'Tous les encadrants gratuits',
  'leader.free.rate.enum.NO_FREE_RATE': 'Pas de gratuité',
  'leader.free.rate.enum.ONE_PER_TEN': '1 pour 10',
  'leader.free.rate.enum.ONE_PER_FIFTEEN': '1 pour 15',
  'leader.free.rate.enum.ONE_PER_TWENTY': '1 pour 20',
  'leader.free.rate.enum.ONE_PER_TWENTY_FIVE': '1 pour 25',
  'leader.free.rate.enum.ONE_PER_THIRTY': '1 pour 30',

  //Transport Mode Enum Mapping ----------------------------------------------------------------
  'transport.mode.enum.WALK': 'Marche',
  'transport.mode.enum.BUS_PASS': "Transport inclus dans l'abonnement de bus",
  'transport.mode.enum.EXTRA_BUS_OR_TRAIN': 'Coût supplémentaire pour le bus/train',

  // Outing Duration Enum Mapping ----------------------------------------------------------------
  'outing.duration.enum.FULL_DAY': 'Journée complète',
  'outing.duration.enum.HALF_DAY': 'Demi-journée',

  // host family price type Enum Mapping ----------------------------------------------------------------
  'host.family.price.type.enum.STUDENT': 'Etudiant',
  'host.family.price.type.enum.STAFF': 'Encadrant',

  //friend place enum mapping ----------------------------------------------------------------
  'friend.place.enum.SAME_FAMILY': 'Même famille',
  'friend.place.enum.SAME_CENTER': 'Même centre',

  //trip step type enum mapping ----------------------------------------------------------------
  'trip.step.type.enum.INBOUND': 'Aller',
  'trip.step.type.enum.OUTBOUND': 'Retour',

  //TEFL Type Enum Mapping ----------------------------------------------------------------
  'tefl.type.enum.TUITION_ACTIVITY': 'Cours + activités',
  'tefl.type.enum.TUITION_ONLY': 'Cours seulement',
  'tefl.type.enum.FULL_DAY_OUTING': 'Sortie journée',
  'tefl.type.enum.ACTIVITY_ONLY': 'Activité seulement',

  //personality enum mapping -----------------------------------------------------------------
  'personality.enum.ENERGETIC': 'Énergique',
  'personality.enum.ARTISTIC': 'Artiste',
  'personality.enum.ATHLETIC': 'Athlétique',
  'personality.enum.SHY': 'Timide',
  'personality.enum.SOCIABLE': 'Sociable',
  'personality.enum.STUDIOUS': 'Studieux',
  'personality.enum.TALKATIVE': 'Bavard',
  'personality.enum.INDEPENDENT': 'Indépendant',

  //interest enum mapping -----------------------------------------------------------------
  'interest.enum.CITY': 'La ville',
  'interest.enum.COUNTRYSIDE': 'La campagne',
  'interest.enum.ANIMALS': 'Les animaux',

  //asthma severity enum mapping ----------------------------------------------------------------
  'asthma.severity.enum.MILD': 'Asthme léger',
  'asthma.severity.enum.SEVERE': 'Asthme Important',

  //filters ----------------------------------------------------------------
  'filters.apply': 'Appliquer',
  'filters.reset': 'Réinitialiser',
  'filters.title': 'Filtrer par',

  //RadioButton active state ----------------------------------------------------------------
  'radio.button.active': 'Actif',
  'radio.button.inactive': 'Inactif',
  'radio.button.both': 'Les deux',

  //password placeholder ----------------------------------------------------------------
  'password.placeholder': 'Mot de passe',

  //forget password ----------------------------------------------------------------
  'forgot.password': 'Vous avez oublié votre mot de passe ?',
  'forgot.password.title': 'Bienvenue à nouveau!',
  'forgot.password.subtitle': 'Mot de passe oublié',

  //Authenticate token ----------------------------------------------------------------
  'authenticate.token.error.hint':
    'Demandez un nouveau lien de connexion depuis votre page de connexion.',
  'authenticate.token.error.cta': 'Recevoir un nouveau lien de connexion',

  //Reset password ----------------------------------------------------------------
  'reset.password.title': 'Bienvenue de nouveau!',
  'reset.password.subtitle': 'Réinitialiser le mot de passe',
  'reset.password.new': 'Nouveau mot de passe',

  //dynamic data table ----------------------------------------------------------------
  'dynamic.data.table.delete.label': 'Supprimer',
  'dynamic.data.table.delete.one.label': 'Etes-vous sûr de vouloir supprimer ce {{message}}?',
  'dynamic.data.table.delete.many.label': 'Êtes-vous sûr de vouloir supprimer ces {{message}}?',
  'dynamic.data.table.delete.all.label':
    'Êtes-vous sûr de vouloir supprimer tous les {{message}}?',
  'dynamic.data.table.delete.confirm': 'Confirmer',
  'dynamic.data.table.delete.cancel': 'Fermer',
  'host.family.filters.status.label': 'Statut',
  'host.family.filters.status.both': 'Les deux',
  'host.family.filters.status.deactivated': 'Désactivé',
  'host.family.filters.status.active': 'Actif',
  'host.family.filters.city.label': 'Ville',
  'host.family.filters.town.label': 'Commune',
  'host.family.filters.lec.comments.label': 'Commentaires LEC',
  'host.family.filters.lec.comments.both': 'Les deux',
  'host.family.filters.lec.comments.has': 'A des commentaires',
  'host.family.filters.lec.comments.no': 'Pas de commentaires',
  'host.family.filters.date.of.visit.label': 'A hébergé dans les 2 dernières années',
  'host.family.filters.date.of.visit.all': 'Tous',
  'host.family.filters.date.of.visit.has': 'A hébergé',
  'host.family.filters.date.of.visit.no': "N'a pas hébergé",
  'host.family.forms.deactivation.label': 'Désactiver cette famille',
  'host.family.forms.deactivation.placeholder':
    'Sélectionnez une raison pour désactiver cette famille',
  'host.family.forms.deactivation.info.message':
    'Si vous désactivez une famille, elle ne recevra aucune notification',
  'host.family.forms.deactivation.submit.label': 'Sauvegarder',
  'host.family.forms.deactivation.cancel.label': 'Fermer',
  'host.family.forms.deactivation.locked.by.lec':
    'Famille désactivée par LEC (pas adaptée), seul LEC peut la réactiver',
  'host.family.deactivation.reason.enum.NOT_AVAILABLE_ANYMORE': 'Plus disponible',
  'host.family.deactivation.reason.enum.MOVED_AWAY': 'A déménagé',
  'host.family.deactivation.reason.enum.NOT_SUITABLE': 'Pas adapté',
  'host.family.local.representative.title': 'Représentant local',

  'taught.level.enum.beginner': 'Débutant',
  'taught.level.enum.intermediate': 'Intermédiaire',
  'taught.level.enum.advanced': 'Avancé',

  'tefl.status.label': 'Statut',
  'tefl.status.active': 'Actif',
  'tefl.status.inactive': 'Inactif',
  'tefl.status.both': 'Les deux',
  'tefl.success.message': 'Tefl modifié avec succès',
  'tefl.history.title': 'Historique des séjours',
  'tefl.history.description':
    'Historique des séjours puis note moyenne attribuée par les jeunes au professeur étranger :',
  'tefl.history.columns.centers': 'Centres',
  'tefl.history.columns.dates': 'Dates',
  'tefl.history.columns.formula': 'Formule',
  'tefl.history.columns.average.rating': 'Note donnée par les jeunes',
  'tefl.history.footer.average': 'Moyenne',

  //errors ----------------------------------------------------------------
  'errors.string.required': 'Veuillez saisir {{fieldName}}',
  'errors.string.max': '{{fieldName}} est trop long',
  'errors.string.email': "Format d'email incorrect ",
  'errors.string.list.required': 'Veuillez saisir des valeurs pour {{fieldName}}',
  'errors.string.min.list':
    'Veuillez saisir au moins {{minimumNumberOfItems}} éléments pour {{fieldName}}',

  'errors.date.required': 'Veuillez entrer une {{inputName}}',
  'errors.date.invalid': 'Veuillez entrer une {{inputName}} valide',
  'errors.date.range': '{{inputName}} doit être entre {{minDate}} et {{maxDate}}.',
  'errors.date.max': '{{inputName}} doit être au plus tard le {{maxDate}}.',
  'errors.date.min': '{{inputName}} doit être au plus tôt le {{minDate}}',

  'errors.time.required': 'Veuillez entrer une {{fieldName}}',
  'errors.time.invalid': 'Veuillez saisir une {{fieldName}} valide',

  'errors.enum.required': 'Veuillez sélectionner {{fieldName}}',
  'errors.enum.invalid': 'Veuillez sélectionner une {{fieldName}} valide',
  'errors.enum.list.required': 'Veuillez sélectionner des valeurs pour {{fieldName}}',
  'errors.enum.list.min':
    'Veuillez sélectionner au moins {{minimumNumberOfItems}} éléments pour {{fieldName}}',

  'errors.social.security.number.invalid': 'Veuillez saisir un numéro de sécurité sociale valide',

  'errors.iban.invalid': 'Veuillez saisir un IBAN valide',
  'errors.iban.required': 'Veuillez saisir un IBAN',
  'errors.iban.min': 'IBAN doit comporter au moins 27 caractères',
  'errors.iban.max': 'IBAN doit comporter au plus 34 caractères',
  'errors.iban.invalidUsdAccountNumber':
    'Veuillez saisir un numéro de compte valide (caractères alphanumériques uniquement)',

  'errors.number.required': 'Veuillez saisir {{fieldName}}',
  'errors.number.invalid': 'Veuillez saisir un {{fieldName}} valide',
  'errors.number.positive': '{{fieldName}} doit être positif',
  'errors.number.integer': '{{fieldName}} doit être un entier',
  'errors.number.min': '{{fieldName}} doit être au moins {{minimum}}',
  'errors.number.max': '{{fieldName}} doit être au plus {{maximum}}',
  'errors.number.nonNegative': '{{fieldName}} doit être non négatif',
  'errors.number.decimalPlaces':
    '{{fieldName}} ne peut pas avoir plus de {{decimalPlaces}} décimale(s)',
  'errors.number.list.required': 'Veuillez saisir des valeurs pour {{fieldName}}',
  'errors.number.list.min':
    'Veuillez saisir au moins {{minimumNumberOfItems}} éléments pour {{fieldName}}',

  'errors.password.min': 'Le mot de passe doit contenir au moins 8 caractères',
  'errors.password.max': 'Le mot de passe doit contenir au maximum 20 caractères',
  'errors.password.invalid':
    'Le mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial',

  'errors.phone.required': 'Veuillez saisir un numéro de téléphone',
  'errors.phone.invalid': 'Veuillez saisir un numéro de téléphone valide',

  'errors.rich.text.required': 'Veuillez saisir  un corps',
  'errors.rich.text.invalid': 'Veuillez saisir un corps valide',

  'errors.part.of.the.europian.union':
    'Veuillez préciser si vous faites partie de l’Union Européenne',
  'errors.diploma.name.required': 'Veuillez saisir le NOM du diplôme',

  //buttons ----------------------------------------------------------------
  'button.validate.plus.one': 'Enregistrer +1',
  'button.validate.and.back.to.list': 'Enregistrer et retour',
  'button.validate': 'Enregistrer',
  'button.modal.validate.plus.one': 'Valider +1',
  'button.modal.validate.and.back.to.list': 'Valider et retour à la liste',
  'button.modal.validate': 'Valider',
  'button.close': 'Fermer',
  'button.return': 'Retour',
  'button.add': 'Ajouter',
  'button.continue': 'Continuer',
  'button.confirm': 'Confirmer',
  'button.cancel': 'Fermer',
  'button.delete': 'Supprimer',
  'button.submit': 'Soumettre',
  'button.assign': 'Assigner',

  //Send Email ----------------------------------------------------------------
  'send.email.to': 'À :',
  'send.email.subject': 'Objet',
  'send.email.body': 'Écrivez votre message ici',
  'send.email.attachments': 'Joindre des fichiers',
  'send.email.attachments.upload': 'Glisser-déposer ou parcourir',
  'send.email.send': 'Envoyer',

  //file upload ----------------------------------------------------------------
  'file.upload.drag.and.drop': 'Glisser-déposer ou parcourir',
  'file.upload.title': 'Importer le document',
  'common.noImages': 'Aucune image disponible',
  'common.click.to.enlarge': "Cliquez sur une photo pour l'agrandir",

  // common ----------------------------------------------------------------
  'common.no.comments': 'Aucune remarque',
  'common.no.feedback': 'Aucune appréciation',
  'common.year': 'Année',
  'common.days': 'jours',
  'common.to': 'à',
  'common.back.to.admin.space': 'Revenir à l’espace admin',
  'common.pagination.show': 'Afficher',
  'common.pagination.per.page': 'par page',
  'common.pagination.previous': 'Précédent',
  'common.pagination.next': 'Suivant',
  'common.no.results': 'Aucun résultat à afficher',
  'common.select.none': 'Aucune',
  'common.select.add.option': 'Ajouter "{{value}}"',
  'common.modal.accept': 'Accepter',
  'common.status.toggle.active': 'Activé',
  'common.status.toggle.inactive': 'Désactivé',
  'center.groups.title': 'Sous-groupes',
  'center.groups.students.assigned': '{{total}} Étudiants assignés',
  'center.groups.student.assigned': '{{total}} Étudiant assigné',
  'center.groups.documents': '{{total}} Documents',
  'center.groups.document': '{{total}} Document',
  'center.groups.no.tefl.assigned': 'Aucun TEFL assigné',
  'center.groups.assign.tefl.title': 'Assigner un TEFL',
  'center.groups.assign.tefl.select': 'Sélectionner un TEFL',
  'center.groups.assign.tefl.none': 'Aucun',
  'center.groups.assign.tefl.success': 'TEFL assigné avec succès',
  'center.groups.unassign.tefl.success': 'TEFL désassigné avec succès',
  'center.groups.documents.title': 'Gérer les documents',
  'center.groups.documents.placeholder': 'Glisser-déposer ou parcourir',
  'center.groups.documents.upload': 'Importer un document',
  'center.groups.documents.success': 'Document ajouté avec succès',
  'center.groups.view.students.title': 'Voir les étudiants - {{name}}',
  'center.groups.students.journeys': 'Séjours',
  'center.groups.students.enrollment.number': "N° d'inscription",
  'center.groups.students.last.name': 'NOM',
  'center.groups.students.first.name': 'Prénom',
  'center.groups.students.age': 'Âge',
  'center.groups.students.gender': 'Sexe',
  'center.groups.students.class': 'Classe',
  'center.groups.students.health': 'Santé',
  'center.groups.students.friends': 'Amis associés',
  'center.groups.close': 'Fermer',
  'center.events.title': 'Evènements en séjour',
  'common.data.table.order': "# d'ordre",
  'center.events.columns.type': "Type d'évènement",
  'center.events.columns.created.at': 'Evènement créé le',
  'center.events.columns.dates': 'Dates de séjour',
  'center.events.columns.student': 'NOM du jeune',
  'center.events.columns.assigned.to': 'Suivi par',
  'center.events.columns.last.activity': 'Dernière activité',
  'center.events.columns.inactive.duration': "Durée d'inactivité",
  'center.events.inactive.duration.days': '{{total}}J',
  'center.events.columns.country': 'Pays',
  'center.events.columns.period': 'Période',
  'center.events.columns.status': 'Statut',
  'center.event.type.enum.HEALTH': 'Santé',
  'center.event.type.enum.DISCIPLINE': 'Discipline',
  'center.event.type.enum.ACCOMODATION': 'Hébergement / Nourriture',
  'center.event.type.enum.COURSE': 'Cours',
  'center.event.type.enum.ACTIVITY': 'Activités',
  'center.event.type.enum.TRAVEL': 'Voyage',
  'center.event.type.enum.MONEY': 'Argent',
  'center.event.type.enum.DIVERS': 'Divers',
  'center.event.type.enum.FA2E_NOT_WANTED': 'FA2E non voulu',
  'center.event.type.enum.SUPERVISION': 'Encadrement',
  'center.event.type.enum.REPATRIATION': 'Rapatriement',
  'center.event.type.enum.CLAIM': 'Réclamation',
  'center.event.status.enum.CREATED': 'À assigner',
  'center.event.status.enum.IN_PROGRESS': 'En cours',
  'center.event.status.enum.SOLVED': 'Clôturés',

  //STAFF PERSONAL SPACE ----------------------------------------------------------------
  'staff.personal.space': 'Mon espace personnel',
  'staff.personal.space.availability': 'Disponibilité',
  'staff.personal.space.pay.scale': 'Barème de rémunération',
  'staff.personal.space.my.journeys': 'Mes séjours',
  'staff.personal.space.my.journeys.home': 'Accueil',

  // address details ----------------------------------------------------------------
  'address.label': 'Nom du lieu',
  'address.address1.label': 'Adresse',
  'address.address2.label': "Complément d'adresse",
  'address.zipCode.label': 'Code postal',
  'address.details.city': 'Ville',

  //staff profile ----------------------------------------------------
  'staff.personal.space.academic.zone': 'Zone Académique',
  'staff.personal.space.social.security.number': 'N° de sécurité sociale',
  'staff.personal.space.birth.date': 'Date de naissance',
  'staff.personal.space.birth.place': 'Pays de naissance',
  'staff.personal.space.birth.department': 'Département de naissance',
  'staff.personal.space.birth.city': 'Ville de naissance',
  'staff.personal.space.spoken.languages': 'Langues parlées',

  //staff personal space my journeys -----------------------------------------------------
  'staff.personal.space.my.journeys.title': 'Séjours',
  'staff.personal.space.my.journeys.subtitle': 'Tous les séjours',
  'staff.personal.space.my.journeys.information':
    "Accéder aux informations de votre séjour (guides, horaires de voyages, liste d'appel, résultats au test de niveau, etc. )",
  'staff.personal.space.my.journeys.information.empty': 'Aucun séjour trouvé',

  //staff personal space my journey details -----------------------------------------------------
  'staff.personal.space.my.journeys.details.tab.home': 'Accueil',
  'staff.personal.space.my.journeys.details.tab.guide': 'Guides à lire avant votre séjour',
  'staff.personal.space.my.journeys.details.trip.time': 'Mes horaires de voyages',
  'staff.personal.space.my.journeys.details.students': 'Listes des Jeunes',
  'staff.personal.space.my.journeys.details.students.invalid.id.or.center.data':
    'ID ou données du centre invalides',
  'staff.personal.space.my.journeys.details.cannot.view.activities.and.budget':
    "  Vous n'avez pas le droit de consulter le programme des activités et du budget de ce séjour pour le moment",
  'staff.personal.space.my.journeys.details.activities.and.budget':
    "Programme d'activités et Budget",
  'staff.personal.space.my.journeys.details.questionnaire': 'Questionnaire Complémentaire',
  'staff.personal.space.my.journeys.details.expenses.note': 'Ma note de frais',
  'staff.personal.space.my.journeys.details.daily.report': 'Rapport quotidien',
  'staff.personal.space.my.journeys.details.end.of.stay.report': 'Rapport de fin de séjour',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.residenceFacilities':
    'Qu’avez-vous pensé du collège/résidence et de ses installations ?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.managementTeam':
    'Qu’avez-vous pensé de l’équipe de direction ?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.peersInvolvement':
    'Qu’avez-vous pensé de l’implication de vos homologues ?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.excursionsFeedback':
    'Qu’avez-vous pensé des excursions/sorties organisées par LEC ?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.activitiesEvenings.professors':
    'Professeurs : Qu’avez-vous pensé des activités et des soirées proposées au sein du collège/résidence ?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.activitiesEvenings.animators':
    'Animateurs : Qu’avez-vous pensé de la participation des professeurs aux activités et aux soirées ?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.classroomEquipment':
    'Qu’avez-vous pensé des salles de cours et des équipements pédagogiques (pour les professeurs) ou du matériel (pour les animateurs) à disposition ?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.foodQuality':
    'Qu’avez-vous pensé de la nourriture en général ?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.residenceImprovements':
    'Voyez-vous des améliorations à apporter dans le cadre d’un séjour en collège/résidence ?',
  'staff.personal.space.my.journeys.details.end.of.stay.questions.additionalRemarks':
    'Autres remarques :',
  'staff.personal.space.my.journeys.details.expenses.okay.for.hotel': "OK pour nuit d'hôtel",
  'staff.personal.space.my.journeys.details.expenses.sent.to.lec.at': 'Envoyée à LEC le {{date}}',
  'staff.personal.space.my.journeys.details.expenses.note.details.title':
    'A noter, pour les professeurs résidant en province, LEC rembourse :',
  'staff.personal.space.my.journeys.details.expenses.note.details.1':
    'Frais de transport A/R domicile ➜ Paris pour vous rendre à la Réunion de préparation avant le séjour :',
  'staff.personal.space.my.journeys.details.expenses.note.details.2':
    'Frais de transport A/R domicile ➜ Lieu de départ/retour pour vous rendre sur le lieu de départ/retour du séjour',
  'staff.personal.space.my.journeys.details.expenses.note.details.3':
    '<strong>La totalité de vos frais ne pourra excéder 170€ par séjour.</strong>',
  'staff.personal.space.my.journeys.details.expenses.note.details.4':
    'Au-delà de ce forfait, en toute hypothèse, <strong>LEC ne remboursera pas les sommes engagées.</strong>',
  'staff.personal.space.my.journeys.details.expenses.note.details.5':
    "<strong>En dehors de ces frais, aucun autre remboursement (frais d'essence, parking, péage, repas, taxi, etc.) ne sera pris en charge.</strong>",
  'staff.personal.space.my.journeys.details.expenses.note.sentence.1':
    "Pour chacune des dépenses que vous avez effectuées, merci de compléter le formulaire ci-dessous et d'y attacher le justificatif correspondant.",
  'staff.personal.space.my.journeys.details.expenses.note.sentence.2':
    'Il est impératif de nous adresser tous vos frais en une seule fois. Une fois ce formulaire validé, aucune autre dépense pour ce séjour ne pourra être ajouter par la suite.',
  'staff.personal.space.my.journeys.details.expenses.trip.table.title':
    'Frais de voyage engagés pour votre séjour / mission',
  'staff.personal.space.my.journeys.details.expenses.preparatory.table.title':
    'Frais de voyage engagés pour la réunion préparatoire',
  'staff.personal.space.my.journeys.details.expenses.trip.table.footer.add.label': 'Ajouter',
  'staff.personal.space.my.journeys.details.expenses.preparatory.table.footer.add.label':
    'Ajouter',
  'staff.personal.space.my.journeys.details.expenses.table.header.date': 'Date',
  'staff.personal.space.my.journeys.details.expenses.table.header.details': 'Détail de la dépense',
  'staff.personal.space.my.journeys.details.expenses.table.header.currency': 'Devise',
  'staff.personal.space.my.journeys.details.expenses.table.header.amount': 'Montant',
  'staff.personal.space.my.journeys.details.expenses.table.header.amount.staff':
    'Montant saisi (ME)',
  'staff.personal.space.my.journeys.details.expenses.table.header.amount.lec':
    'Montant validé (LEC)',
  'staff.personal.space.my.journeys.details.expenses.table.header.proof': 'Justificatif',
  'staff.personal.space.my.journeys.details.expenses.flat.fees':
    'Total (Forfait maximum de {{flatFees}})',
  'staff.personal.space.my.journeys.details.expenses.total': 'Total',
  'staff.personal.space.my.journeys.details.expenses.save.and.continue':
    'Enregistrer et continuer plus tard',
  'staff.personal.space.my.journeys.details.expenses.validate.and.send.to.lec':
    'Valider et envoyer à LEC',

  'staff.personal.space.my.journeys.details.expenses.validation.error':
    'Veuillez vérifier que tous les champs sont correctement remplis',

  'staff.personal.space.my.journeys.details.expenses.submission.success':
    'Votre demande de remboursement a été soumise avec succès.',

  //staff personal space my journey details Home -----------------------------------------------------
  'staff.personal.space.my.journeys.details.tab.home.title': 'Accueil',

  'staff.personal.space.my.journeys.details.tab.home.journey.info.title': 'Informations du séjour',
  'staff.personal.space.my.journeys.details.tab.home.journey': 'Séjour',
  'staff.personal.space.my.journeys.details.tab.home.journey.day': 'jour(s)',
  'staff.personal.space.my.journeys.details.tab.home.journey.night': 'nuit(s)',
  'staff.personal.space.my.journeys.details.tab.home.journey.qualification': 'Qualification',
  'staff.personal.space.my.journeys.details.tab.home.journey.themes': 'Thème(s)',
  'staff.personal.space.my.journeys.details.tab.home.journey.options': 'Option(s)',
  'staff.personal.space.my.journeys.details.tab.home.journey.formulas': 'Formule(s)',

  'staff.personal.space.my.journeys.details.tab.home.trip': 'Voyage',
  'staff.personal.space.my.journeys.details.tab.home.view.trip.data':
    'Voir le détail de mon voyage',

  'staff.personal.space.my.journeys.details.tab.home.teaching.halls.not.found':
    'Aucune salle de cours renseignée',
  'staff.personal.space.my.journeys.details.tab.home.teaching.halls': 'Lieux des cours',
  'staff.personal.space.my.journeys.details.tab.home.teaching.halls.name': 'Nom',
  'staff.personal.space.my.journeys.details.tab.home.teaching.halls.address': 'Adresse',

  'staff.personal.space.my.journeys.details.tab.home.organizer.local': 'Organisateur Local (OL)',
  'staff.personal.space.my.journeys.details.tab.home.organizer.firstName': 'Prénom',
  'staff.personal.space.my.journeys.details.tab.home.organizer.lastName': 'Nom',
  'staff.personal.space.my.journeys.details.tab.home.organizer.phone': 'Numéro de téléphone',
  'staff.personal.space.my.journeys.details.tab.home.organizer.email': 'Email',

  'staff.personal.space.my.journeys.details.tab.home.rad.title': "Réunion d'information",
  'staff.personal.space.my.journeys.details.tab.home.rad.date': 'Date',
  'staff.personal.space.my.journeys.details.tab.home.rad.hour': 'Heure',
  'staff.personal.space.my.journeys.details.tab.home.rad.location': 'Lieu',

  'staff.personal.space.my.journeys.details.tab.guide.cta': 'Découvrir le guide complet',
  'staff.personal.space.my.journeys.details.tab.guide.no.guides':
    'Aucun guide disponible pour le moment',

  'staff.personal.space.my.journeys.details.tab.home.urgent.number.title': "Numéro d'urgence",
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.text':
    "À contacter uniquement pendant le séjour, en dehors des horaires d'ouverture de bureau",
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.lec': "Numéro d'urgence LEC",
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.view.fac':
    'Voir les n° des FAC Paris',

  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.title':
    "Coordonnées d'urgence LEC Paris",
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.office.number':
    'Numéro du bureau LEC à Paris',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.french.hour':
    'Heure française',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.monday.thursday':
    'Lundi - Jeudi',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.friday.saturday':
    'Vendredi - Samedi',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.FAC.numbers.title':
    'Numéros des FAC Paris',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.FAC.numbers.text':
    'À contacter en priorité en cas de problème pendant le séjour',
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.journey':
    "Numéro d'urgence séjour",
  'staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.lec.journey.text':
    'À contacter uniquement pendant le séjour, en dehors des horaires d’ouverture de bureau et si le(s) FAC Paris ne répond(ent) pas',

  'staff.personal.space.my.journeys.details.tab.home.my.team': 'Mon équipe',

  'staff.personal.space.my.journeys.details.tab.home.contact.details.host.family':
    'Coordonnées de ma famille-hôtesse',
  'staff.personal.space.my.journeys.details.tab.home.contact.accommodation':
    'Coordonnées de l’hébergement',

  'staff.personal.space.my.journeys.details.tab.home.contact.details.host.family.mrs': 'Madame',
  'staff.personal.space.my.journeys.details.tab.home.contact.details.host.family.mr': 'Monsieur',
  'staff.personal.space.my.journeys.details.tab.home.contact.details.host.family.empty':
    'Aucune famille-hôtesse assignée pour le moment',

  // staff personal space my journeys details activities
  'staff.personal.space.my.journeys.details.tab.home.activities.download.program':
    'Télécharger le programme',
  'staff.personal.space.my.journeys.details.tab.home.activities.download.program.with.budget':
    'Télécharger le programme détaillé avec budget',

  // Travel Expenses -----------------------------------------------------
  'travel.expenses.validate': 'Valider',
  'travel.expenses.open': 'Débloquer',
  'travel.expenses.open.for.staff': "Débloquer pour l'encadrant",
  'travel.expenses.validation.error':
    'Veuillez vérifier que tous les champs sont correctement remplis.',
  'travel.expenses.validation.save': 'Enregistrer',
  'travel.expenses.submission.success':
    'Votre demande de remboursement a été soumise avec succès.',
  'travel.expenses.table.header.proof': 'Justificatif',
  'travel.expenses.preparatory.table.title':
    'Frais de voyage engagés pour la réunion préparatoire',
  'travel.expenses.preparatory.table.footer.add.label': 'Ajouter',
  'travel.expenses.trip.table.title': 'Frais de voyage engagés pour votre séjour / mission',
  'travel.expenses.trip.table.footer.add.label': 'Ajouter',

  //staff login -----------------------------------------------------------
  'staff.personal.space.connect': 'Se connecter',
  'staff.personal.space.welcome': 'Bienvenue sur votre Espace Personnel LEC !',

  //Staff form --------------------------------------------------------------
  'staff.personal.space.personal.info': 'Informations personnelles',
  'staff.personal.space.contracts': 'Mes contrats',
  'staff.personal.space.missions': 'Mes missions',
  'staff.personal.space.to.complete': 'A compléter',
  'staff.personal.space.my.profile': 'Mon profil',
  'staff.personal.space.progress.percentage': 'de vos informations sont complétées',
  'staff.personal.space.missing.documents': 'Documents manquants:',
  'staff.personal.space.missing.iban': 'IBAN',
  'staff.personal.space.missing.emergency.contact.details': "Coordonnées du contact d'urgence",
  'staff.personal.space.address': 'Adresse',
  'staff.personal.space.postal.code': 'Code postal',
  'staff.personal.space.city': 'Ville',
  'staff.personal.space.country': 'Pays',
  'staff.personal.space.supplementary.address': "Complément d'adresse",
  'staff.personal.space.civil.status': 'Situation de famille',
  'staff.personal.space.number.of.children': "Nombre d'enfants",
  'staff.personal.space.hobbies': 'Loisirs',
  'staff.personal.space.allergies': 'Allergies',
  'staff.personal.space.professional.details': 'Détails professionnels',
  'staff.personal.space.current.status': 'Situation actuelle',
  'staff.personal.space.field.of.study': "Domaine d'étude",
  'staff.personal.space.education.level': "Niveau d'études",
  'staff.personal.space.taught.class.level': 'Niveau de classe enseigné',
  'staff.personal.space.establishments': 'Établissements',
  'staff.personal.space.establishment.name': 'NOM de l’établissement',
  'staff.personal.space.establishment.city': 'Ville de l’établissement',
  'staff.personal.space.establishment.address': "Adresse de l'établissement",
  'staff.personal.space.establishment.postal.code': "Code postal de l'établissement",
  'staff.personal.space.diplomas': 'Diplômes',
  'staff.personal.space.diplomas.info':
    'Ajouter une copie de chaque diplôme que vous avez déclaré posséder',
  'staff.personal.space.other': 'Autre',
  'staff.personal.space.degree.name': 'NOM du diplôme',
  'staff.personal.space.adminstrative.files': 'Documents administratifs',
  'staff.personal.space.identity.document': "Pièce d'identité",
  'staff.personal.space.identity.subtitle': 'Avec laquelle vous voyagerez',
  'staff.personal.space.identity.card': "Carte d'identité",
  'staff.personal.space.identity.card.first.info':
    "Saisir les informations telles qu'elles figurent sur la<br/>pièce d'identité avec laquelle vous voyagerez et<br/>présenterez lors des contrôles d'identité et formalités<br/>de voyages (enregistrement, contrôles de police,<br/> etc...)",
  'staff.personal.space.identity.card.second.info':
    " Pour rappel, votre pièce d'identité doit être valable<br/>jusqu’à la date de fin de séjour, et 6 mois après la<br/>date de fin de séjour pour les séjours aux USA,<br/>Canada et Australie.",
  'staff.personal.space.identity.card.third.info':
    "En cas d'erreur de saisie ou d'information erronée,<br/>vous vous verrez malheureusement refuser le départ<br/>et ne pourrez pas encadrer le séjour, le retour vers<br/>votre domicile serait alors à votre charge.",
  'staff.personal.space.passport': 'Passeport',
  'staff.personal.space.date.of.issue': 'Date de délivrance',
  'staff.personal.space.expiration.date': "Date d'expiration",
  'staff.personal.space.issuing.country': 'Pays émetteur',
  'staff.personal.space.payslip': 'Bulletin de paie',
  'staff.personal.space.payslip.subtitle':
    "Ajouter votre dernière fiche de paie afin de confirmer<br/>votre appartenance à l'Éducation nationale et de<br/>vérifier votre CAPES, PLP2 ou Agrégation pour<br/>l'attribution de votre prime",
  'staff.personal.space.DBS': 'Casier judiciaire',
  'staff.personal.space.DBS.subtitle': 'Datant de moins de 3 mois',
  'staff.personal.space.DBS.first.info':
    'Ajouter un extrait de casier judiciaire de moins de 3<br/>mois.',
  'staff.personal.space.DBS.second.info':
    'Pour obtenir votre extrait de casier judiciaire rendez-<br/>vous sur : ',
  'staff.personal.space.eta.subtitle':
    'Votre exemption de visa si vous encadrez un séjour en Angleterre, Ecosse, USA, ou Canada',
  'staff.personal.space.your.bank.details': 'Vos coordonnées bancaires',
  'staff.personal.space.bank.info':
    'Les coordonnées bancaires saisies doivent impérativement <br/>être celles d’un compte bancaire français à vos NOM et <br/>prénom. En cas d’erreur de saisie, le délai de paiement de <br/>vos honoraires sera alors allongé.',
  'staff.personal.space.has.complementary.insurance': 'Avez-vous une assurance complémentaire?',
  'staff.personal.space.complementary.insurance.name': "NOM de l'assurance complémentaire",
  'staff.personal.space.in.case.of.emergency': "En cas d'urgence",
  'staff.personal.space.in.case.of.emergency.info':
    'Merci de saisir les coordonnées d’une personne à contacter <br/>en cas d’urgence durant votre séjour',
  'staff.personal.space.emergency.contact.name': "NOM du contact d'urgence",
  'staff.personal.space.emergency.contact.relationship': "Relation du contact d'urgence",
  'staff.personal.space.phone.number': 'N° de téléphonne',
  'staff.personal.space.nationality': 'Nationalité',
  'staff.personal.space.date.of.birth': 'Date de naissance',
  'staff.personal.space.country.of.birth': 'Pays de naissance',
  'staff.personal.space.city.of.birth': 'Ville de naissance',
  'staff.personal.space.diploma.name': 'NOM du diplôme',
  'staff.personal.space.diploma': 'Diplôme',

  // staff contracts ----------------------------------------------------------------
  'staff.personal.space.contracts.dates': 'Date du contrat',
  'staff.personal.space.contracts.country': 'Pays',
  'staff.personal.space.contracts.position': 'Poste',
  'staff.personal.space.contracts.qualification': 'Qualification',
  'staff.personal.space.contracts.net.remuneration.before.PASE': 'Rémunération nette avant PAS',
  'staff.personal.space.contracts.status': 'Status',
  'staff.personal.space.contracts.date.of.signature': 'Date de signature',
  'staff.personal.space.contracts.view': 'Voir mon contrat',
  'staff.personal.space.mission.date': 'Date mission',
  'staff.personal.space.mission.title': 'Libellé',
  'staff.personal.space.mission.pay': 'Rémunération',
  'staff.personal.space.mission.contract.sent.at': "Date d'envoi",
  'staff.personal.space.mission.contract.signed.at': 'Date de signature',

  // staff missions ----------------------------------------------------------------
  'staff.personal.space.missions.date': 'Date de la mission',
  'staff.personal.space.missions.title': 'Libellé',
  'staff.personal.space.missions.meeting.place': 'Lieu de RDV',
  'staff.personal.space.missions.appointment.time': 'Heure de RDV',
  'staff.personal.space.missions.instructions': 'Instructions de la mission',
  'staff.personal.space.missions.repport': 'Rapport de mission',
  'staff.personal.space.missions.repport.view': 'Voir le rapport',
  'staff.personal.space.missions.repport.complete': 'Compléter le rapport',
  'staff.personal.space.missions.notes': 'Notes de frais',

  'staff.personal.space.missions.instructions.print.pdf': 'Voir le détail',
  'staff.personal.space.missions.instructions.notes.access': 'Accéder',
  'staff.personal.space.missions.instructions.notes.add': 'Ajouter',

  'staff.personal.space.missions.report.title': 'Rapport de Mission',
  'staff.personal.space.missions.report.mission.date': 'Date de la mission',
  'staff.personal.space.missions.report.mission.title': 'Libellé de la mission',
  'staff.personal.space.missions.report.mission.meeting.place': 'Lieu de RDV',
  'staff.personal.space.missions.report.start.time': 'Heure de début de la mission',
  'staff.personal.space.missions.report.end.time': 'Heure de fin de la mission',
  'staff.personal.space.missions.report.content.title':
    'Remarques et incidents éventuels liés au déroulement de la mission',
  'staff.personal.space.missions.report.content.placeholder':
    'Remarques et incidents éventuels liés au déroulement de la mission',
  'staff.personal.space.missions.report.comments.title':
    'Appréciation sur l’hébergement – à compléter en cas de séjour à l’hôtel durant la mission :',
  'staff.personal.space.missions.report.comments.placeholder': 'Commentaires',
  'staff.personal.space.missions.report.content.error':
    'Veuillez saisir le contenu du rapport de mission',

  //STAFF PERSONAL SPACE AVAILABILITY ----------------------------------------------------------------
  'staff.personal.space.availability.title': 'Vos disponibilités ainsi que les séjours assignés',
  'staff.personal.space.availability.first.information.part.one':
    'Ici, vous pouvez gérer vos disponibilités.',
  'staff.personal.space.availability.first.information.part.two':
    'Pour ajouter une nouvelle période de disponibilité, sélectionnez directement une plage de dates sur le calendrier (minimum 6 jours consécutifs).',
  'staff.personal.space.availability.first.information.part.two.aat':
    'Pour ajouter une nouvelle période de disponibilité, sélectionnez directement une plage de dates sur le calendrier.',
  'staff.personal.space.availability.first.information.part.three':
    'Pour modifier ou supprimer une période existante, cliquez simplement sur celle-ci.',
  'staff.personal.space.availability.second.information.part.one': 'Vous pouvez également ',
  'staff.personal.space.availability.second.information.part.two':
    'sélectionner les formules de séjours que vous souhaitez encadrer,',
  'staff.personal.space.availability.second.information.part.three':
    "ainsi que les destinations souhaitées pour l'encadrement de votre prochain séjour linguistique.",
  'staff.personal.space.availability.list.of.countries': 'Liste de pays souhaités',
  'staff.personal.space.availability.formula.wishlist': 'Liste de formules souhaitées',
  'staff.personal.space.availability.add.availability': 'Ajouter une disponibilité',
  'staff.personal.space.availability.month': 'Mois',
  'staff.personal.space.availability.year': 'Année',
  'staff.personal.space.availability.contract': 'Contrat',
  'staff.personal.space.availability.contract.from': 'du',
  'staff.personal.space.availability.mission': 'Mission',
  'staff.personal.space.availability.Avaialable.from': 'Disponible du',
  'staff.personal.space.availability.to': 'au',
  'staff.personal.space.availability.new.availability': 'Nouvelle disponibilité',
  'staff.personal.space.availability.edit.availability': 'Modifier la disponibilité',
  'staff.personal.space.availability.form.date.from': 'Date de',
  'staff.personal.space.availability.form.date.to': 'Date à',
  'staff.personal.space.availability.form.delete.message':
    'Êtes-vous sûr de vouloir supprimer cette disponibilité ?',
  'sso.login.success':
    'Veuillez vérifier votre e-mail pour le lien de connexion à votre espace personnel.',

  //STAFF PERSONAL SPACE PAY SCALE ----------------------------------------------------------------
  'staff.personal.space.pay.scale.title': 'Barème de rémunération des {{position}}',
  'staff.personal.space.pay.scale.terms.note':
    'Modalités de remboursement de vos frais de transport',
  'staff.personal.space.pay.scale.Box.title':
    'Rémunérations nettes avant application du prélèvement à la source.',
  'staff.personal.space.pay.scale.Box.first.info.title':
    'Pour les professeurs enseignants : prime de qualification capes et/ou Agrégation',
  'staff.personal.space.pay.scale.Box.first.info.title.explanation':
    'diplôme en votre possession le jour du recrutement',
  'staff.personal.space.pay.scale.Box.first.info.one': 'Pour les séjours de 7, 8 et 12 jours :',
  'staff.personal.space.pay.scale.Box.first.info.two': 'Pour les séjours au-delà de 12 jours :',
  'staff.personal.space.pay.scale.Box.first.general':
    'Cette prime ne concerne pas les séjours sans cours dispensés : Un professeur pour un élève, Club 4, collèges internationaux et toutes formules à Malte.',
  'staff.personal.space.pay.scale.Box.second.info.title': 'LEC prend en charge :',
  'staff.personal.space.pay.scale.Box.second.info.one':
    'Hébergement, pension-complète et blanchissage en famille ou en Collège/Résidence',
  'staff.personal.space.pay.scale.Box.second.info.two':
    'Les frais de voyage aller-retour de la ville de départ du groupe à la ville de destination de séjour',
  'staff.personal.space.pay.scale.Box.third.info.title':
    'A noter, pour les {{position}} résidant en province, LEC rembourse :',
  'staff.personal.space.pay.scale.Box.third.info.one': 'Frais de transport A/R domicile',
  'staff.personal.space.pay.scale.Box.third.info.one.two':
    'Paris pour vous rendre à la Réunion de préparation avant le séjour',
  'staff.personal.space.pay.scale.Box.third.info.two': 'Frais de transport A/R domicile',
  'staff.personal.space.pay.scale.Box.third.info.two.two':
    'Lieu de départ/retour pour vous rendre sur le lieu de départ/retour du séjour',
  'staff.personal.space.pay.scale.Box.third.info.three':
    'La totalité de vos frais ne pourra excéder 170€ par séjour.',
  'staff.personal.space.pay.scale.Box.third.general.light':
    'Au-delà de ce forfait, en toute hypothèse, ',
  'staff.personal.space.pay.scale.Box.third.general.bold':
    'LEC ne remboursera pas les sommes engagées.',
  'staff.personal.space.pay.scale.Box.general.ending.one':
    "En dehors de ces frais, aucun autre remboursement (frais d'essence, parking, péage, repas, taxi, etc.) ne sera pris en charge.",
  'staff.personal.space.pay.scale.Box.general.ending.two':
    '*La rémunération des séjours de 8 jours (toutes formules, tous pays), de 14 et 15 jours (séjour PO Malte uniquement) inclue 1 journée de congés payés.',

  //STAFF PERSONAL SPACE PAY SCALE TABLE -------------------------------------------------
  'staff.personal.space.pay.scale.table.per.day': 'Par jour ({{currency}})',
  'staff.personal.space.pay.scale.table.per.8.days': '8 jours* ({{currency}})',
  'staff.personal.space.pay.scale.table.per.13.days': '13 jours ({{currency}})',
  'staff.personal.space.pay.scale.table.per.14.days': '14 jours ({{currency}})',
  'staff.personal.space.pay.scale.table.per.14.days.malta': '14 jours* ({{currency}})',

  //STAFF PERSONAL SPACE PAY SCALE AAT ---------------------------------------------------
  'staff.personal.space.pay.scale.aat.title':
    "Barème de rémunérations des Animateurs d'Accueil et de Transfert",
  'staff.personal.space.pay.scale.aat.table.title': 'Libellé',
  'staff.personal.space.pay.scale.aat.table.qualification': 'Qualification',
  'staff.personal.space.pay.scale.aat.table.pay': 'Rémunération (€)',

  // STAFF PERSONAL SPACE TRAVEL SCHEDULE -------------------------------------------------
  'staff.personal.space.travel.schedule.reminder.about.the.expense.reimbursement.policy':
    'Au retour, votre responsabilité s’achève une fois que tous les jeunes ont été confiés à leurs parents ou à un responsable LEC. Si vous avez un train à prendre ensuite pour rentrer à votre domicile, prévoyez au minimum 1 heure de marge après l’horaire de retour prévu (sans compter votre temps de trajet vers la gare suivante).',
  'staff.personal.space.travel.schedule.my.meeting.points': 'Mes horaires et points de RDV',
  'staff.personal.space.travel.schedule.schedules.not.available.yet':
    'Vos horaires de voyage seront mis en ligne au plus tard 20 jours avant votre départ. Vous recevrez un email de notification dès qu’ils seront disponibles.',
  'staff.personal.space.travel.schedule.french.leader.meetings.instructions.one':
    'Vous trouverez ci-dessous vos horaires et le lieu de rendez-vous. En cliquant sur le nom du lieu, vous pouvez accéder à plus de précisions.',
  'staff.personal.space.travel.schedule.french.leader.meetings.instructions.two':
    'Si vous venez de province, merci de réserver au plus vite vos billets pour rejoindre le lieu de départ. Si possible, privilégiez des billets annulables et/ou modifiables.',
  'staff.personal.space.travel.schedule.french.leader.meetings.instructions.attention':
    'Rappel des modalités de remboursement de frais',

  'staff.personal.space.travel.schedule.dispatch.place.card.date.of.departure': 'Date de départ',
  'staff.personal.space.travel.schedule.dispatch.place.card.date.of.arrival': "Date d'arrivée",
  'staff.personal.space.travel.schedule.dispatch.place.card.departure.address':
    'Lieu de RDV Encadrant',
  'staff.personal.space.travel.schedule.dispatch.place.card.arrival.address': "Lieu d'arrivée",
  'staff.personal.space.travel.schedule.dispatch.place.card.rdv.meeting.time':
    'Heure de RDV Encadrant',
  'staff.personal.space.travel.schedule.dispatch.place.card.company': 'Compagnie',
  'staff.personal.space.travel.schedule.dispatch.place.card.arrival.time': "Heure d'arrivée",
  'staff.personal.space.travel.schedule.dispatch.place.card.departure.place': 'Lieu de départ',
  'staff.personal.space.travel.schedule.dispatch.place.card.arrival.place': "Lieu d'arrivée",
  'staff.personal.space.travel.schedule.dispatch.place.card.departure.time': 'Heure de départ',

  'staff.personal.space.travel.schedule.checklist.title':
    'Check-liste des choses à prévoir le jour du départ',
  'staff.personal.space.travel.schedule.checklist.subtitle':
    'Les indispensables pour votre départ',
  'staff.personal.space.travel.schedule.checklist.item.one':
    "Vérifiez et préparez vos papiers d'identité",
  'staff.personal.space.travel.schedule.checklist.item.two': 'Pour éviter tout stress inutile',
  'staff.personal.space.travel.schedule.checklist.item.two.details':
    'prévoyez d’arriver en avance au point de rendez-vous',
  'staff.personal.space.travel.schedule.checklist.item.three':
    'Portez votre blouson rouge et présentez-vous au responsable départ LEC',
  'staff.personal.space.travel.schedule.checklist.item.four':
    'N’oubliez pas les documents remis lors de la réunion de préparation',
  'staff.personal.space.travel.schedule.checklist.item.five':
    'Pensez à prendre votre panier repas pour le jour du voyage',

  'staff.personal.space.travel.schedule.checklist.item.one.one.title': 'Angleterre et Écosse',
  'staff.personal.space.travel.schedule.checklist.item.one.one.details':
    'Passeport + ETA (à demander sur le site officiel)',
  'staff.personal.space.travel.schedule.checklist.item.one.two.title':
    'Irlande, Malte, Allemagne, Espagne, France',
  'staff.personal.space.travel.schedule.checklist.item.one.two.details':
    "Carte d'identité ou passeport",
  'staff.personal.space.travel.schedule.checklist.item.one.three.title': 'États-Unis',
  'staff.personal.space.travel.schedule.checklist.item.one.three.details':
    'Passeport + ESTA (à demander sur le site officiel)',
  'staff.personal.space.travel.schedule.checklist.item.one.four.title': 'Canada',
  'staff.personal.space.travel.schedule.checklist.item.one.four.details':
    'Passeport + AVE (à demander sur le site officiel)',

  'staff.personal.space.travel.schedule.group.itinerary.foreign.provider.place.lable':
    'Lieu de RDV {{name}} prestataire étranger',
  'staff.personal.space.travel.schedule.group.itinerary.title':
    "Itinéraire du groupe que j'encadre durant le trajet",
  'staff.personal.space.travel.schedule.foreign.leader.checklist.item.one.title':
    'Pour éviter tout stress inutile',
  'staff.personal.space.travel.schedule.foreign.leader.checklist.item.one.details':
    'Prévoyez d’arriver en avance au point de rendez-vous',
  'staff.personal.space.travel.schedule.foreign.leader.checklist.item.two.one': 'Portez votre',
  'staff.personal.space.travel.schedule.foreign.leader.checklist.item.two.two': 'blouson rouge',
  'staff.personal.space.travel.schedule.foreign.leader.checklist.item.two.three':
    'et présentez-vous au',
  'staff.personal.space.travel.schedule.foreign.leader.checklist.item.two.four':
    'responsable départ LEC',
  'staff.personal.space.travel.schedule.foreign.leader.options.title':
    'Vous avez la possibilité soit de rejoindre le groupe à {{meetingPlace}}, soit de vous rendre au collège par vos propres moyens. Quelle option préférez-vous ?',
  'staff.personal.space.travel.schedule.foreign.leader.options.title.attend.alone':
    'Vous vous rendez au collège par vos propres moyens. Merci de confirmer ce choix.',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group':
    'Je rejoins le groupe à {{meetingPlace}}',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.generic':
    'Je rejoins le groupe',
  'staff.personal.space.travel.schedule.foreign.leader.options.attend.alone':
    'Je me rends au collège par mes propres moyens',

  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.departure.label':
    'Vous êtes attendu :',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.rdv.hour':
    'Heure de RDV',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.rdv.place':
    'Lieu de RDV',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.dropoff.hour':
    'Drop-off time',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.dropoff.place':
    'Drop-off place',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.contact.label':
    'Contact des autres encadrants à retrouver au point de RDV :',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.note':
    'Vous pouvez contacter les autres encadrants du voyage si vous avez des difficultés à trouver le car. S’ils ne répondent pas, vous pouvez également retrouver la personne basée dans le hall d’arrivée de St Pancras (elle porte une veste rouge "LEC" et veille à ce que les groupes trouvent le car à leur arrivée)',
  'staff.personal.space.travel.schedule.foreign.leader.options.join.group.bus.text':
    'Le bus vous déposera :',

  'staff.personal.space.travel.schedule.foreign.leader.attend.alone.return.text':
    'Vous pouvez quitter le collège à partir de 11h. ',
  'staff.personal.space.travel.schedule.foreign.leader.attend.alone.departure.text':
    "Vous êtes attendu à l'adresse suivante :",
  'staff.personal.space.travel.schedule.foreign.leader.attend.alone.address.label': 'Adresse',
  'staff.personal.space.travel.schedule.foreign.leader.attend.alone.time.label': 'Heure',
  'staff.personal.space.travel.schedule.foreign.leader.attend.alone.responsible.label':
    'Responsable centre :',
  'staff.personal.space.travel.schedule.foreign.leader.attend.alone.note':
    'Merci de contacter le responsable du centre  à votre arrivée sur le Collège',

  'staff.personal.space.travel.schedule.group.itinerary.no.reservations':
    'Aucune réservation disponible',
  'staff.personal.space.travel.schedule.group.itinerary.reservation.title':
    'Réservations (tous les horaires sont en heures locales)',
  'staff.personal.space.travel.schedule.group.itinerary.reservation.arrival.label': 'Arrivée',
  'staff.personal.space.travel.schedule.group.itinerary.reservation.departure.label': 'Départ',
  'staff.personal.space.travel.schedule.group.itinerary.reservation.departure.transfer.title':
    "Transfert à l'arrivée dans le pays de séjour",
  'staff.personal.space.travel.schedule.group.itinerary.reservation.return.transfer.title':
    "Transfert depuis votre centre de séjour vers la gare/ l'aéroport/ le port",
  'staff.personal.space.travel.schedule.group.itinerary.foreign.provider.appointment.label':
    'Heure de RDV {{name}} prestataire étranger',

  //COMMISSIONS ----------------------------------------------------------------
  'commissions.appliedToHost.header': "Type d'hôte",
  'commissions.products.header': 'Produits',
  'commissions.formulas.header': 'Formules',
  'commissions.countries.header': 'Pays',
  'commissions.countries.hours.per.day': 'heures/jour',
  'commissions.hours.per.week.header': 'Heures de cours / sem',
  'commissions.fa1ePrice.header': 'Prix par nuit FA1E',
  'commissions.fa1ePrice.per.week.header': 'Total FA1E/semaine (7 nuits)',
  'commissions.ol.fees.per.fa1ePrice.header': 'Prix par pax FA1E (jeunes et encadrants)',
  'commissions.fa1ePrice.10h.week.total.header': 'Total FA1E/semaine (10h)',
  'commissions.fa1ePrice.15h.week.total.header': 'Total FA1E/semaine (15h)',
  'commissions.fa2ePrice.header': 'Prix par nuit FA2E',
  'commissions.fa2ePrice.per.week.header': 'Total FA2E/semaine (7 nuits)',
  'commissions.ol.fees.per.fa2ePrice.header': 'Prix par pax FA2E (jeunes et encadrants)',
  'commissions.fa2ePrice.10h.week.total.header': 'Total FA2E/semaine (10h)',
  'commissions.fa2ePrice.15h.week.total.header': 'Total FA2E/semaine (15h)',
  'commissions.visitPackPrice.header': 'Supplément pack visites par semaine (OTO)',
  'commissions.price.header': 'Prix',
  'commissions.otoPerHourPrice.per.week.header': 'Supplément pack visites hebdomadaire (OTO)',
  'commissions.otoPerHourPrice.header': 'Prix par heure de cours (OTO)',
  'commissions.currency.header': 'Devise',
  'commissions.periods.header': 'Période(s)',
  'commissions.family.arrangement.header': 'Modalités d’accueil',
  'commissions.providers.header': 'Prestataires',
  'commissions.applied.durations.in.days.header': 'Durée du séjour (nuits)',
  'commissions.categories.header': 'Catégories',
  'commissions.filters.year': 'Année',
  'commissions.filters.products': 'Produits',
  'commissions.filters.formulas': 'Formules',
  'commissions.filters.durations.in.days': 'Durées (nuits)',
  'commissions.filters.periods': 'Période(s)',
  'commissions.filters.family.arrangement': 'Modalités d’accueil',
  'commissions.advancePayment.header': "Montant de l'avance",
  'commissions.retainer.header': 'Montant du retainer',
  'commissions.adminFeePerStudent.header': 'Prix dépenses admin par jeune',
  'commissions.tuitionAndActivity.header': 'Cours + Activités',
  'commissions.tuitionOnly.header': 'Cours uniquement',
  'commissions.activityOnly.header': 'Activités uniquement',
  'commissions.fullDayOuting.header': 'Journée complète',

  //words ----------------------------------------------------------------
  to: 'à',

  //Activity Table ----------------------------------------------------------------
  'activity.table.name': 'Nom',
  'activity.table.address': 'Adresse',
  'activity.table.activitySplitAge': 'Split Age (Activity)',
  'activity.table.leaderFreeRatio': 'Ratio de gratuité adulte',
  'activity.table.comments': 'Commentaires',
  'activity.table.transportSplitAge': 'Split Age (Transport)',
  'activity.table.transportMode': 'Mode de transport',
  'activity.table.ChildCost': 'Coût enfant',
  'activity.table.AdultCost': 'Coût adulte',
  'activity.table.LeaderCost': 'Coût encadrant',
  'activity.table.FlatGroupCost': 'Coût groupe fixe',

  //Mobile Number For French Leaders Table ----------------------------------------------------------------
  'mobile.number.for.french.leaders.table.phoneNumber': 'Numéro de téléphone',

  //Coach Company Table ----------------------------------------------------------------
  'coach.company.table.name': 'Nom',
  'coach.company.table.phoneNumber': 'Numéro de téléphone',
  'coach.company.table.comments': 'Commentaires',
  'coach.company.table.add.coach.company': 'Ajouter une compagnie de bus',
  'coach.company.created.successfully': 'Compagnie de bus créée avec succès',
  'coach.company.assigned.successfully': 'La compagnie de transport a été assignée avec succès.',
  'coach.company.form.name': 'Nom',
  'coach.company.form.phone.number': 'Numéro de téléphone',
  'coach.company.form.emergency.number': "Numéro d'urgence",
  'coach.company.form.address1': 'Adresse',
  'coach.company.form.address2': "Complément d'adresse",
  'coach.company.form.city': 'Ville',
  'coach.company.form.zip.code': 'Code postal',
  'coach.company.form.country': 'Pays',
  'coach.company.form.comments': 'Commentaire',

  //Ol Center Table ----------------------------------------------------------------
  'ol.center.table.header.name': 'Nom du centre',
  'ol.center.table.header.date': 'Dates du séjour',
  'ol.center.table.header.product.type': 'Type',
  'ol.center.table.students': '# de jeunes affectés',
  'ol.center.table.french.leaders': 'Encadrants français',
  'ol.center.table.placed.students': "# d'encadrants français",
  'ol.center.table.unplaced.students': 'Jeunes non placés',
  'ol.center.table.placed.staffs': 'Encadrants placés',
  'ol.center.table.unplaced.staffs': 'Encadrants non placés',
  'ol.center.table.affected.students': '# de jeunes affectés',
  'ol.center.table.affected.staffs': "# d'encadrants français",
  'ol.center.table.students.already.distributed.to.presta': '# de jeunes déjà diffusés au presta',
  'ol.center.table.distribution.of.client.information': 'Diffusion des infos aux clients',
  'ol.center.table.advance.money.transfer': 'Virement Avance',
  'ol.center.table.before.stay.money.transfer': 'Virement avant séjour',
  'ol.center.table.balance.money.transfer': 'Virement du solde',
  'ol.center.table.update.status': '# de jeunes à diffuser au presta',
  'ol.center.table.travel.info': 'Diffusion horaire voyage au presta étranger',
  'ol.center.table.travel.transfer.details': 'Transfer Details',
  'ol.center.table.activity.program': 'Activity programme',
  'ol.center.table.cost.of.center': 'Cost of centre',
  'ol.center.table.teaching.hall': 'Teaching hall',
  'ol.center.table.final.cost': 'Final Cost',
  'ol.center.table.students.evaluation': 'Diffusion des appréciations de fin de séjour',
  'ol.center.table.students.evaluation.pending': "A compléter par l'OL",
  'ol.center.table.host.family.diffused':
    'Toutes les informations ont été partagées avec les parents',
  'ol.center.table.host.family.not.diffused':
    'Les informations n’ont pas été partagées avec les parents',
  'ol.center.table.travel.info.diffused': 'Diffusé au presta',
  'ol.center.table.travel.info.first.diffusion.pending': 'Première diffusion non effectuée',
  'ol.center.table.travel.info.not.diffused': 'Modif à diffuser au presta ',
  'ol.center.table.travel.info.new.diffusion': 'Nouvelles infos voyage à consulter',
  'ol.center.table.travel.info.not.defined': 'Instructions non disponibles',
  'ol.center.table.mobile.number.for.FL': 'Mobile number for FL',
  'ol.center.table.mobile.number.for.FL.allocated.tooltip': 'Affecté',
  'ol.center.table.mobile.number.for.FL.to.allocate.tooltip': 'À affecter',
  'ol.center.table.teaching.hall.assign.tooltip': 'Assigné',
  'ol.center.table.teaching.hall.to.assign.tooltip': 'À assigner',

  // Center OL Payments ----------------------------------------------------------------
  'center.costs.ol.payments.title': 'Virements effectués',
  'center.costs.ol.payments.advanced.payment': 'Virement avance',
  'center.costs.ol.payments.balance.transfer': 'Virement de la balance',
  'center.costs.ol.payments.advance.amount': "Montant d'avance :",
  'center.costs.ol.payments.column.date': 'Date',
  'center.costs.ol.payments.column.type': 'Type',
  'center.costs.ol.payments.column.amount': 'Montant',
  'center.costs.ol.payments.column.status': 'Statut',

  // Center Costs Table ----------------------------------------------------------------
  'center.costs.cost.of.center': 'Virements',
  'center.costs.cost.of.center.and.money.transfers': 'Virements & Cost of center',
  'center.costs.synchronize.costs': 'Synchroniser',
  'center.costs.synchronize.costs.validation.title':
    'Êtes-vous sûr de vouloir remettre les paramètres initialement saisis dans les tables (Fees Prestas LEC, prix des familles, TEFL, teaching halls…) ? Les modifications faites à la main dans le cost of center seront perdues.',
  'center.costs.synchronize.costs.validation.confirm': 'Synchroniser',
  'center.costs.synchronize.costs.validation.cancel': 'Annuler',
  'center.costs.print.costs': 'Imprimer',
  'center.costs.validate': 'Valider',
  'center.costs.unvalidate': 'Débloquer',
  'center.costs.reopen': 'Réouvrir au prestataire',
  'center.costs.upload.invoice': 'Upload invoice',
  'center.costs.missing.invoices.title': 'Please upload the missing invoice(s)',
  'center.costs.missing.invoices.for': 'For “{{title}}” {{key}}',

  // Cost Missing Invoices
  'center.costs.missing.invoices.exceptional.expenses': 'Expenses',
  'center.costs.missing.invoices.activities': 'Activities',
  'center.costs.missing.invoices.transfers': 'Transfers',
  'center.costs.missing.invoices.cultural.outings': 'Cultural Outings',
  'center.costs.missing.invoices.teaching.hall.costs': 'Teaching Hall Costs',
  'center.costs.missing.invoices.tefl.costs': 'TEFL Costs',

  // Editable Table Tooltip ----------------------------------------------------------------
  'editableTable.tooltip.initialValue': 'Initial',
  'editableTable.tooltip.olValue': 'Prestataire',

  // Final Balance
  'center.costs.final.balance.title.final.balance': 'Final balance',
  'center.costs.final.balance.total.amounts.previously.transferred':
    'Total amounts previously transferred',
  'center.costs.final.balance.total.final.amount': 'Total final amount',
  'center.costs.final.balance.total.balance': 'Total Balance *',
  'center.costs.final.balance.note':
    '*If the amount is owed to LEC, it will be displayed in green. If the amount is owed to LO, it will be displayed in red',
  'center.costs.final.balance.confirmational.message':
    'I confirm that I have paid all the amounts detailed on this form relating to this language course.',
  'center.costs.final.balance.signed.on': 'Signé le',
  'center.costs.final.send.to.lec': 'Send to LEC',
  'center.costs.final.unlock': 'Débloquer',
  'center.costs.final.final.transfer.cost': 'Virement final cost',
  'center.costs.final.validate': 'Valider',

  //Local Organisers
  'center.costs.local.organisers.fees.title': "Local organiser's fees per student & leaders",
  'center.costs.local.organisers.fees.table.header.pax': 'Pax',
  'center.costs.local.organisers.fees.table.header.fees': 'Fees',
  'center.costs.local.organisers.fees.table.header.total.cost': 'Total cost',
  'center.costs.local.organisers.fees.table.footer.total.fees': 'Total fees',

  // Host Family
  'center.costs.host.family.title': 'Host family',
  'center.costs.host.family.table.header.pax': 'Pax',
  'center.costs.host.family.table.header.cost.per.night': 'Cost / Night',
  'center.costs.host.family.table.header.cost.per.host.family': 'Cost / HF',
  'center.costs.host.family.table.header.cost.tuition.per.week': 'Cost tuition /week',
  'center.costs.host.family.table.header.cost.supply.visits.per.week': 'Suppl visits/week',
  'center.costs.host.family.table.header.total.cost': 'Total cost',
  'center.costs.host.family.table.footer.total.host.family': 'Total HF',

  // TEFL teachers & leaders
  'center.costs.tefl.teachers.and.leaders.title': 'TEFL teachers & leaders',
  'center.costs.tefl.teachers.and.leaders.table.header.number.of.tefl': '# TEFL',
  'center.costs.tefl.teachers.and.leaders.table.header.number.of.days': '# Days',
  'center.costs.tefl.teachers.and.leaders.table.header.cost.per.day': 'Cost/day',
  'center.costs.tefl.teachers.and.leaders.table.header.cost.per.tefl': 'Cost/TEFL',
  'center.costs.tefl.teachers.and.leaders.table.header.cost.total': 'Total cost',
  'center.costs.tefl.teachers.and.leaders.table.footer.total.host.family':
    'Total local teachers/leaders',

  // Teaching hall
  'center.costs.teaching.hall.title': 'Teaching hall',
  'center.costs.teaching.hall.table.add.a.teaching.hall': 'Add a teaching hall',
  'center.costs.teaching.hall.table.header.number.of.classrooms': '# Rooms',
  'center.costs.teaching.hall.table.header.hours.per.classroom': 'Hrs/Day',
  'center.costs.teaching.hall.table.header.number.of.days': '# Days',
  'center.costs.teaching.hall.table.header.cost.per.day': 'Cost per day',
  'center.costs.teaching.hall.table.header.fixed.cost': 'Fixed cost',
  'center.costs.teaching.hall.table.header.total.cost': 'Total costs',
  'center.costs.teaching.hall.table.footer.total.teaching.hall': 'Total Teaching hall',

  // Detailed Activities Table ----------------------------------------------------------------
  'center.costs.detailed.activities.table.group.title.activity.cost': 'Activity cost',
  'center.costs.detailed.activities.table.group.title.french.leader.admin.expenses':
    'French leader admin expenses',
  'center.costs.detailed.activities.table.group.title.local.transport.ftr.and.french.leaders':
    'Local transport (FTR & French leaders)',
  'center.costs.detailed.activities.table.header.programmes': 'Programmes',
  'center.costs.detailed.activities.table.header.number.of.students': '# of students',
  'center.costs.detailed.activities.table.header.number.of.staffs': '# of staffs',
  'center.costs.detailed.activities.table.header.average.cost.per.student':
    'Average cost per student',
  'center.costs.detailed.activities.table.header.total.cost': 'Total cost',
  'center.costs.detailed.activities.table.header.cost.per.student': 'Cost per student',
  'center.costs.detailed.activities.table.header.number.of.students.ftr.and.french.leaders':
    '# of students (FTR) & French leaders',
  'center.costs.detailed.activities.table.header.local.transport.ftr.and.french.leaders':
    'Local transport (FTR & French leaders)',
  'center.costs.detailed.activities.table.header.activity.cost': 'Activity cost',
  'center.costs.detailed.activities.table.header.french.leader.admin.expenses':
    'French leader admin expenses',
  'center.costs.detailed.activities.table.total.budget.of.the.center':
    'Total Budget of the center',

  // Cultural outings
  'center.costs.cultural.outings.title':
    'Cultural outings / activity transportation (coaches booked)',
  'center.costs.cultural.outings.table.header.cultural.outings': 'Cultural Outing/Activity',
  'center.costs.cultural.outings.table.header.cultural.outings.label': 'Cultural Outing/Activity',
  'center.costs.cultural.outings.table.header.total.cost': 'Total cost',
  'center.costs.cultural.outings.table.footer.total.total.transportation.coaches.booked':
    'Total Transportation (coaches booked)',

  // Arrival/Departure Transfers
  'center.costs.arrival.departure.transfers.title': 'Arrival/Departure Transfers',
  'center.costs.arrival.departure.transfers.table.header.from.to': 'From/ To',
  'center.costs.arrival.departure.transfers.table.header.quotation': 'Quotation',
  'center.costs.arrival.departure.transfers.table.header.quotation.label': 'Quotation',
  'center.costs.arrival.departure.transfers.table.header.total.cost': 'Total costs',
  'center.costs.arrival.departure.transfers.table.footer.total.transfers.cost':
    'Total transfer cost',

  // Budget given to the French leader`
  'center.costs.french.leader.budget.details.title': 'Budget details',
  'center.costs.french.leader.budget.title': 'Budget given to the French leader',
  'center.costs.french.leader.budget.table.header.activity.budget.paid.by.french.leader':
    'Activity budget paid by the FL',
  'center.costs.french.leader.budget.table.header.admin.expenses': 'Admin expenses',
  'center.costs.french.leader.budget.table.header.total.costs': 'Total costs',
  'center.costs.french.leader.budget.table.header.total.activity.budget': 'Admin expenses',
  'center.costs.tefl.teachers.and.leaders.table.header.upload.invoices': 'Upload invoices',
  'center.costs.tefl.teachers.and.leaders.table.header.upload.receipts': 'Upload receipt',
  'center.costs.french.leader.budget.table.header.french.leaders.local.transport':
    'Local Transport (FTR & French leaders)',
  'center.costs.french.leader.budget.table.footer.label':
    'Total budget given to the French leader',
  'center.costs.french.leader.budget.upload.invoice':
    'Upload the receipt for the budget of the center',

  // Activity budget paid by local organiser
  'center.costs.activity.budget.title': 'Activity budget paid by local organiser',
  'center.costs.activity.budget.table.header.activities': 'Activities',
  'center.costs.activity.budget.table.header.total.cost': 'Total cost',
  'center.costs.activity.budget.table.footer.total.activity.budget.paid.by.local.organiser':
    'Total activity budget paid by local organiser',

  // Miscellaneous
  'center.costs.miscellaneous.title': 'Miscellaneous',
  'center.costs.miscellaneous.table.header.reason': 'Reason',
  'center.costs.miscellaneous.table.header.amount': 'Amount',
  'center.costs.miscellaneous.table.button.add.miscellaneous': 'Add miscellaneous',
  'center.costs.miscellaneous.table.footer.total.miscellaneous': 'Total miscellaneous',

  // Center Total Costs Table ----------------------------------------------------------------
  'center.costs.totals.grand.total': 'Grand total',
  'center.costs.balance': 'Balance',

  // Center Costs Status ----------------------------------------------------------------
  'center.costs.status.send.to.lec': 'Send to LEC',
  'center.costs.status.sent.to.lec.on': 'Cost of center sent to LEC on',

  // Center Final Costs ----------------------------------------------------------------
  'center.final.costs.title': 'Final cost',
  'center.final.costs.instructions.title': 'Final Cost Form - Instructions',
  'center.final.costs.instructions.number.of.students.and.leaders':
    'The number of students & leaders (single/double placements) is automatically calculated based on the actual host family placements.',
  'center.final.costs.instructions.fields.highlighted.in.red':
    'Fields highlighted in red indicate differences from the initial "Cost of Centre" data. Hovering over these fields will display the previous values for comparison.',
  'center.final.costs.instructions.you.can.edit.fields':
    'You can edit any fields that were originally filled in the "Cost of Centre" by clicking directly into the corresponding box.',
  'center.final.costs.instructions.it.is.essential.to.upload.all.invoices':
    'It is essential to upload all invoices to justify the reported costs. Please ensure that the total amount on each invoice matches the amount stated in this final cost.',
  'center.costs.save': 'Sauvegarder',

  'center.final.costs.print.final.costs': 'Imprimer le final cost',
  'center.final.costs.fees': 'Total Fees',
  'center.final.costs.footer.initial.amaount': 'Initial Amount',
  'center.final.costs.footer.final.amount': 'Final amount',
  'center.final.costs.footer.balance': 'Balance',

  //ol center journey badge ----------------------------------------------------------------
  'ol.center.journey.badge.title': 'Séjours',

  //ol center enrollment table columns ----------------------------------------------------------------
  'ol.center.enrollment.table.columns.student.placed': 'Statut diffusion aux parents',
  'ol.center.enrollment.table.columns.diffusion.date.parents':
    'Date dernière diffusion aux parents',
  'ol.center.enrollment.table.columns.host.family': 'Famille-hôtesse',
  'ol.center.enrollment.table.columns.familyArrangement': "Modalité d'hébergement",
  'ol.center.enrollment.table.familyArrangement.FA1E': 'Un seul français dans la famille',
  'ol.center.enrollment.table.familyArrangement.FA2E': 'Deux français dans la famille',
  'ol.center.enrollment.table.columns.lastName': 'Nom du jeune',
  'ol.center.enrollment.table.columns.firstName': 'Prénom du jeune',
  'ol.center.enrollment.table.columns.host.family.info.sent.to.parents':
    'Infos famille-hôtesse envoyées aux parents',
  'ol.center.enrollment.table.columns.host.family.info.sent.by.lec.to.the.parents':
    'Infos envoyées aux parents par LEC',
  'ol.center.enrollment.table.columns.age': 'Âge',
  'ol.center.enrollment.table.columns.classLevel': 'Classe',
  'ol.center.enrollment.table.columns.gender': 'Sexe',
  'ol.center.enrollment.table.columns.medicalStatus': 'Santé',
  'ol.center.enrollment.table.columns.friends': 'Amis',
  'ol.center.enrollment.table.columns.center.group': 'Sous-groupe',
  'ol.center.enrollment.table.columns.journeys': 'Séjour',
  'ol.center.enrollment.table.columns.diffusion.date.presta':
    'Date de diffusion du jeune au presta',
  'ol.center.enrollment.table.columns.option': 'Option',
  'ol.center.enrollment.table.columns.acknowledgement': 'Accusé de réception',

  //ol center enrollment table actions ----------------------------------------------------------------
  'ol.center.enrollment.table.actions.email.student.info.to.HF':
    'Envoyer les infos du jeune à la famille-hôtesse',
  'ol.center.enrollment.table.actions.download.id.picture': 'Télécharger la photo d’identité',
  'ol.center.enrollment.table.actions.print.placement.test.results':
    'Télécharger les résultats du test de placement',
  'ol.center.enrollment.table.actions.print.detailed.test.results':
    'Imprimer les résultats du test de placement',
  'ol.center.enrollment.table.actions.download.roaster.list': 'Télécharger la liste des jeunes',
  'ol.center.enrollment.table.actions.print.my.placement.list.by.name.of.student':
    'Imprimer ma liste de placements par nom de jeune',
  'ol.center.enrollment.table.actions.print.my.placement.list.by.name.of.FH':
    'Imprimer ma liste de placements par nom de FH',
  'ol.center.enrollment.table.actions.print.my.student.list.with.health.problem':
    'Imprimer ma liste de jeunes avec problème de santé',

  //ol center capsule tabs ----------------------------------------------------------------
  'ol.center.capsule.tabs.placement.and.diffusion': 'Placements & diffusion aux parents',
  'ol.center.capsule.tabs.placement.and.diffusion.residence': 'Placements & diffusion aux parents',
  'ol.center.capsule.tabs.center.groups': 'Sous-groupe',
  'ol.center.capsule.tabs.cost.of.center': 'Virements & Cost of center',
  'ol.center.capsule.tabs.simple.cost.of.center': 'Virements',
  'ol.center.capsule.tabs.program.and.activities':
    "Programme d'activités & budget & TEFL & Teaching hall",
  'ol.center.capsule.tabs.simple.program.and.center.address':
    "Programme d'activités & Adresses du centre",
  'ol.center.capsule.tabs.simple.program.and.teaching.hall':
    "Programme d'activités & Teaching Hall",
  'ol.center.capsule.tabs.travel.info': 'Infos voyage',
  'ol.center.capsule.tabs.final.cost': 'Final cost',
  'ol.center.capsule.tabs.events': 'Evènements en séjour',
  'ol.center.capsule.tabs.end.of.stay.appreciations': 'Appréciation des jeunes',
  'center.end.of.stay.appreciations.received': '{{received}}/{{enrolled}} questionnaires reçus',
  'center.end.of.stay.appreciations.title': 'Appréciation des jeunes',
  'center.end.of.stay.appreciations.export': 'Exporter les notes Excel',
  'center.end.of.stay.appreciations.response.rate': '% de réponse',
  'center.end.of.stay.appreciations.average': 'Moyenne',
  'center.end.of.stay.appreciations.columns.youths': 'Liste des jeunes',
  'center.end.of.stay.appreciations.columns.last.name': 'NOM',
  'center.end.of.stay.appreciations.columns.first.name': 'Prénom',
  'center.end.of.stay.appreciations.columns.age': 'Âge',
  'center.end.of.stay.appreciations.columns.gender': 'Sexe',
  'center.end.of.stay.appreciations.columns.questions': 'Liste des questions',
  'ol.center.end.of.stay.appreciations.diffused.success':
    'Les appréciations de fin de séjour ont bien été diffusées au prestataire.',

  //ol center ----------------------------------------------------------------
  'ol.center.back.button': 'Retour',
  'ol.center.prestataire': 'Prestataire',
  'ol.center.lec.phone.number': 'Tél. du LEC',
  'ol.center.print.the.students.list': 'Imprimer la liste des jeunes',
  'ol.center.print.global.list': 'Imprimer la liste globale',
  'ol.center.print.list.by.proram': 'Imprimer la liste par programme',
  'ol.center.print.list.by.sub.group': 'Imprimer la liste par sous-groupe',
  'ol.center.print.list.by.transport.type': 'Imprimer la liste par type de transport',
  'ol.center.print.enrollments.pickup.list': 'Liste personne désignée au retour - voyages indiv',
  'ol.center.placement.diffusion.title': 'Placements & diffusion aux parents',
  'ol.center.placement.diffusion.title.residence': 'Placements & diffusion aux parents',
  'ol.center.placement.diffusion.phone.number': 'Tél. du responsable du centre',
  'ol.center.staff.table.title': 'Liste des encadrants',
  'ol.center.staff.table.diffusion.button': 'Diffusion modif responsable aux parents',
  'ol.center.enrollment.table.title': 'Liste des jeunes',
  'ol.center.enrollment.table.diffusion.button': 'Diffusion info aux parents',
  'ol.center.enrollment.table.print.by.name.of.student.button':
    'Imprimer ma liste de placements par nom de jeune',
  'ol.center.enrollment.table.print.by.name.of.FH.button':
    'Imprimer ma liste de placements par nom de FH',
  'ol.center.enrollment.table.comment.title': 'Commentaires',
  'ol.center.assign.host.family': 'Affecter une famille-hôtesse',
  'ol.center.assign.new.host.family.to.staff':
    'Affecter une nouvelle famille-hôtesse à un encadrant',

  //Teaching Hall Table ----------------------------------------------------------------
  'teaching.hall.table.name': 'Nom',
  'teaching.hall.table.address': 'Adresse',
  'teaching.hall.table.number.of.classrooms': '# de salles de classe',
  'teaching.hall.table.contact': 'Contact',
  'teaching.hall.table.phoneNumber': 'Numéro de téléphone',
  'teaching.hall.success.message': 'Salle de cours modifiée avec succès',

  // affected staffs table ----------------------------------------------------------------
  'affected.staffs.table.firstName': 'Prénom',
  'affected.staffs.table.lastName': 'Nom',
  'affected.staffs.table.qualification': 'Qualification',
  'affected.staffs.table.age': 'Âge',
  'affected.staffs.table.gender': 'Sexe',
  'affected.staffs.table.accommodation': 'Hébergement',

  'staff.personal.space.students.title': 'Listes des Jeunes',
  'staff.personal.space.students.view.list': 'Vue liste',
  'staff.personal.space.students.view.grid': 'Vue Photo',
  'staff.personal.space.my.journeys.details.students.no.enrollments.permission':
    'La liste des jeunes de votre groupe sera mise en ligne au plus tard 30 jours avant votre départ. Vous recevrez un email de notification dès qu’elle sera disponible.',
  'staff.personal.space.students.table.actions.add.request':
    'Voir les fiches sanitaires de liaisons',
  'staff.personal.space.students.table.actions.print.youth.list': 'Imprimer la liste des jeunes',
  'staff.personal.space.students.table.actions.print': 'Imprimer',
  'staff.personal.space.students.table.actions.print.youth.list.by.level':
    'Imprimer la liste des jeunes par niveau',
  'staff.personal.space.students.table.actions.export.youth.list.to.excel':
    'Exporter la liste des jeunes en Excel',
  'staff.personal.space.students.table.actions.print.youth.list.by.host.family':
    "Imprimer la liste des jeunes par famille d'accueil",
  'staff.personal.space.students.columns.last.name': 'Nom',
  'staff.personal.space.students.columns.first.name': 'Prénom',
  'staff.personal.space.students.columns.medical.status': 'Infos santé',
  'staff.personal.space.students.columns.can.go.out.alone': 'Sorties seul le soir autorisées',
  'staff.personal.space.students.columns.can.not.go.out.alone':
    'Sorties seul le soir non autorisées',
  'staff.personal.space.students.columns.aa': 'AA',
  'staff.personal.space.students.columns.age': 'Âge',
  'staff.personal.space.students.columns.gender': 'Sexe',
  'staff.personal.space.students.columns.school.level': 'Classe',
  'staff.personal.space.students.columns.class.level': 'Résultat au test de niveau',
  'staff.personal.space.students.columns.formula': 'Formule',
  'staff.personal.space.students.columns.theme': 'Thème',
  'staff.personal.space.students.columns.optional.option': 'Option Facultative',
  'staff.personal.space.students.columns.main.trip': 'Voyage principal',
  'staff.personal.space.students.columns.departure.city': 'Ville de départ',
  'staff.personal.space.students.columns.parent1.phone.number': 'N° tel parent 1',
  'staff.personal.space.students.columns.parent2.phone.number': 'N° tel parent 2',
  'staff.personal.space.students.columns.student.phone.number': 'N° tel jeune',
  'staff.personal.space.students.columns.friends': 'Ami(s)',
  'staff.personal.space.students.columns.host.family.name': 'Famille-Hôtesse',
  'staff.personal.space.students.columns.host.family.modal.title': 'Détails de la famille hôtesse',
  'staff.personal.space.students.card.parents.contact': 'Contacts parents',
  'staff.personal.space.students.card.emergency.contact': "Contact d'Urgence",
  'staff.personal.space.students.card.health.info': 'Infos santé',
  'staff.personal.space.students.card.insurance': 'Assurance rapatriement',
  'staff.personal.space.students.card.vaccination': 'Vaccinations',
  'staff.personal.space.students.card.status.loading.enrollments': 'Chargement des jeunes...',
  'staff.personal.space.students.card.status.error.loading.enrollments':
    'Erreur lors du chargement des jeunes',
  'staff.personal.space.students.card.status.loading.more.enrollments': 'Chargement des jeunes...',

  'enrollment.vaccinations.diphtheria': 'Diphtérie',
  'enrollment.vaccinations.tetanus': 'Tétanos',
  'enrollment.vaccinations.poliomyelitis': 'Poliomyélite',
  'enrollment.vaccinations.dtPolioTetracoq': 'OU DT Polio / Tétracoq',
  'enrollment.vaccinations.pertussis': 'Coqueluche',
  'enrollment.vaccinations.hepatitisB': 'Hépatite B',
  'enrollment.vaccinations.rubellaMumpsMeasles': 'Rubéole - Oreillons - Rougeole',
  'enrollment.vaccinations.bcg': 'BCG',
  'enrollment.vaccinations.haemophilus': 'Haemophilus',
  'enrollment.vaccinations.pneumococcus': 'Pneumocoque',
  'enrollment.vaccinations.meningococcusC': 'Méningocoque C',
  'enrollment.vaccinations.otherVaccinations': 'Autres vaccins (préciser)',
  'enrollment.vaccinations.additionalRecommendations': 'Recommandations utiles des parents',

  //ol center tooltip ----------------------------------------------------------------
  'ol.center.tooltip.canGoOutAlone': 'Autorisé(e) à sortir seul(e) le soir, max 10pm',
  'no.ol': 'Aucun OL trouvé',

  //ol center host family placement history ----------------------------------------------------------------
  'ol.center.host.family.placement.history.title': 'Historique des placements',
  'ol.center.host.family.placement.history.hostFamily.name': 'Nom FH',
  'ol.center.host.family.placement.history.reason': 'Raison de la modifcation',
  'ol.center.host.family.mixed.gender.title': "Garçon et fille dans la même famille d'accueil",
  'ol.center.host.family.reason.for.change.required': 'Veuillez saisir la raison du changement',

  //ol center placement badges  ----------------------------------------------------------------
  'ol.center.placement.badge.students.in.center.title': 'Jeunes dans le centre',
  'ol.center.placement.badge.staffs.in.center.title': 'Encadrants dans le centre',
  'ol.center.placement.badge.placed': 'Placé',
  'ol.center.placement.badge.not.placed': 'Non placé',

  // ol center placement diffusion success message ----------------------------------------------------------------
  'ol.center.placement.diffusion.host.family.success':
    'La diffusion des familles-hôtesse a été effectuée avec succès.',
  'ol.center.placement.diffusion.center.manager.success':
    'La diffusion des responsables de centre a été effectuée avec succès.',

  //ol center placement change french leader phone number ----------------------------------------------------------------
  'ol.center.placement.change.french.leader.phone.number':
    'Ajouter un numéro de téléphone pour le responsable français',

  //ol center placement change host family ----------------------------------------------------------------
  'ol.center.placement.change.host.family': 'Modifier la famille-hôtesse',
  'ol.center.placement.change.host.family.label': 'Assign teaching hall',

  //ol center trips info ----------------------------------------------------------------
  'ol.center.trips.info.warning.note':
    'Attention : certaines informations ont été modifiées depuis la dernière diffusion.',
  'ol.center.trips.info.title': 'Infos voyage',
  'ol.center.trips.info.date.of.diffusion': 'Date de diffusion',
  'ol.center.trips.info.login.user': 'Login du user LEC',
  'ol.center.trips.info.time.note': 'Tous les horaires sont donnés en heure locale',
  'ol.center.trips.info.diffuse.travel.info': 'Diffuser Infos Voyage au Prestataire',
  'ol.center.trip.booking.success.message':
    'Les informations de voyage ont été diffusées avec succès.',
  'ol.center.trip.booking.not.diffused.title': 'Infos voyage non envoyées',
  'ol.center.trip.booking.not.diffused.message.single':
    'Infos voyage non envoyées par email au prestataire de ce centre :',
  'ol.center.trip.booking.not.diffused.message.multiple':
    'Infos voyage non envoyées par email aux prestataires de ces centres :',
  'ol.center.trip.booking.data.has.not.been.loaded':
    "Les données de voyage n'ont pas été chargées.",
  'ol.center.trip.booking.local.coach.company': 'Local coach company',
  'ol.center.trip.booking.coach.company.name': 'Coach company',
  'ol.center.trip.booking.coach.company.phone.number': 'Numéro de téléphone',
  'ol.center.trip.booking.coach.company.emergency.number': 'Numéro d’urgence',
  'ol.center.trip.booking.arrival.day': 'Jour d’arrivée',
  'ol.center.trip.booking.departure.day': 'Jour de départ',
  'ol.center.trip.booking.no.coach.company.available':
    'Aucune compagnie de bus disponible pour ce voyage',

  //ol center trip booking details ----------------------------------------------------------------
  'ol.center.trip.booking.details.departure.date': 'Date de départ',
  'ol.center.trip.booking.details.departure.location': 'Lieu de départ',
  'ol.center.trip.booking.details.departure.time': 'Heure de départ',
  'ol.center.trip.booking.details.arrival.date': "Date d'arrivée",
  'ol.center.trip.booking.details.arrival.location': "Lieu d'arrivée",
  'ol.center.trip.booking.details.arrival.time': "Heure d'arrivée",
  'ol.center.trip.booking.details.transport.company': 'Compagnie de transport',
  'ol.center.trip.booking.details.transport': 'Transport',
  'ol.center.trip.booking.details.flight.train.number': 'N° de vol/train',
  'ol.center.trip.booking.details.meeting.place.for.company':
    'Lieu de RDV car prestataire étranger',
  'ol.center.trip.booking.details.drop.off.point.for.company':
    'Lieu de dépose du groupe car presta étranger',
  'ol.center.trip.booking.details.drop.off.time.for.company':
    'Heure de dépose du groupe car presta étranger',
  'ol.center.trip.booking.details.meeting.time.for.company':
    'Heure de RDV car prestataire étranger',
  'ol.center.trip.booking.details.instructions.for.company':
    "Consignes à l'arrivée pour le prestataire à l'étranger",
  'ol.center.trip.booking.aller.details.instructions.drop.off.for.company':
    "Consignes à l'arrivée pour le prestataire à l'étranger",
  'ol.center.trip.booking.retour.details.instructions.drop.off.for.company':
    "Consignes au retour pour le prestataire à l'étranger",

  //ol center program and activities ----------------------------------------------------------------
  'ol.center.program.activities.title': 'Cours et programme d’activités',
  'center.costs.program.documents.title': 'Détails du programme',
  'center.costs.program.documents.upload': 'Importer un document',
  'center.costs.program.no.documents.uploaded': 'Aucun document disponible',
  'center.costs.address.title': 'Adresse du centre',
  'center.costs.address.name': 'Nom',
  'center.costs.address.address': 'Adresse',
  'center.costs.address.no.data': 'Aucune donnée disponible',
  'center.costs.address.course.location': 'Lieu des cours (si différent)',
  'center.costs.address.course.address': 'Adresse des cours (si différente)',
  'ol.center.program.activities.planner.title': 'Détails du programme',
  'ol.center.program.activities.planner.arival': 'Arrivée',
  'ol.center.program.activities.planner.departure': 'Départ',
  'ol.center.program.activities.activity.table.title': 'Activités',
  'ol.center.program.activities.local.transport.table.title': 'Local transport',
  'ol.center.program.activities.tefl.table.name': 'TEFL',
  'ol.center.program.activities.tefl.not.assigned': 'Non assigné',
  'ol.center.program.activities.teaching.hall.table.name': 'Teaching hall',
  'ol.center.program.activities.timezone':
    'Remarque : Toutes les heures affichées sont dans le fuseau horaire {{timezone}}',
  'ol.center.program.activities.add.course': 'Ajouter un bloc cours',
  'ol.center.program.activities.sent.to.lec.badge': 'Le programme d’activités a été envoyé au LEC',
  'ol.center.program.activities.print.program': 'Imprimer le programme',
  'ol.center.program.activities.print.program.by.price':
    'Imprimer le programme détaillé avec prix',
  'ol.center.program.activities.add.activity': 'Ajouter une activité',
  'ol.center.program.activities.print.level.tests': 'Imprimer les tests de niveau',
  'ol.center.program.activities.print.level.tests.results':
    'Imprimer les résultats des tests de niveau',
  'ol.center.program.activities.planner.course': 'Cours',
  'ol.center.program.activities.planner.activity.form.create.title': 'Créer une activité',
  'ol.center.program.activities.planner.activity.form.date': 'date',
  'ol.center.program.activities.planner.activity.form.starting.time': 'heure de début',
  'ol.center.program.activities.planner.activity.form.ending.time': 'heure de fin',
  'ol.center.program.activities.planner.activity.form.activity.id': 'activité',
  'ol.center.program.activities.planner.activity.form.comment': 'commentaire',
  'ol.center.program.activities.planner.activity.form.activity.paid.by': 'activité payée par',
  'ol.center.program.activities.planner.activity.form.journey.ids': 'Veuillez choisir un séjour',
  'ol.center.program.activities.planner.activity.form.error.starting.time':
    'L’heure de début doit être avant l’heure de fin.',
  'ol.center.program.activities.planner.activity.form.date.label': 'Date',
  'ol.center.program.activities.planner.activity.form.starting.time.label':
    'Beginning of the activity',
  'ol.center.program.activities.planner.activity.form.ending.time.label': 'End of the activity',
  'ol.center.program.activities.planner.activity.form.activity.id.label': 'Activité',
  'ol.center.program.activities.planner.activity.form.comment.label': 'Commentaire',
  'ol.center.program.activities.planner.activity.form.activity.paid.by.label':
    'Activité payée par',
  'ol.center.program.activities.planner.activity.form.journey.ids.label':
    'Select the programmes concerned by this activity',
  'ol.center.program.activities.planner.activity.form.journey.ids.not.available':
    'Aucun séjour disponible',
  'ol.center.program.activities.planner.activity.form.option.id.label':
    'Élèves concernés par cette activité',
  'ol.center.program.activities.planner.activity.form.option.id.none':
    'Tous les élèves des programmes sélectionnés',
  'ol.center.program.activities.planner.activity.form.option.id.option':
    "Uniquement les élèves ayant réservé l'option « {{option}} »",
  'ol.center.program.activities.planner.activity.form.comment.add': 'Ajouter un commentaire',
  'ol.center.program.activities.planner.activity.form.comment.placeholder':
    'Notez ici toute information utile, comme “arriver 15 minutes avant le début de l’activité,” “apporter une serviette et une crème solaire,” etc.',
  'ol.center.program.activities.planner.activity.form.edit.title': 'Modifier l’activité',
  'ol.center.program.activities.planner.activity.form.delete.title': 'Supprimer l’activité',
  'ol.center.program.activities.planner.course.form.create.title': 'Ajouter un cours',
  'ol.center.program.activities.planner.activity.create.success.message':
    'L’activité a été créée avec succès',
  'ol.center.program.activities.planner.activity.edit.success.message':
    'L’activité a été modifiée avec succès',
  'ol.center.program.activities.planner.activity.delete.success.message':
    'L’activité a été supprimée avec succès',
  'ol.center.program.activities.planner.course.create.success.message':
    'Le bloc cours a été créé avec succès',
  'ol.center.program.activities.planner.open.activity.success.message':
    'Activités ouvertes avec succès',
  'ol.center.program.activities.planner.send.activity.success.message':
    'Activités validées avec succès',
  'ol.center.program.activities.planner.validate.activity.success.message':
    'Activités validées avec succès',
  'ol.center.program.activities.planner.break.included': 'Pause incluse',

  //ol center program course form ----------------------------------------------------------------
  'ol.center.program.course.form.update.title': 'Modifier le cours',
  'ol.center.program.course.form.date': 'Date',
  'ol.center.program.course.form.start.time': 'Heure de début',
  'ol.center.program.course.form.end.time': 'Heure de fin',
  'ol.center.program.course.form.delete.button': 'Supprimer le cours',
  'ol.center.program.course.form.delete.success.message': 'Le cours a été supprimé avec succès',
  'ol.center.program.course.form.edit.success.message': 'Le cours a été modifié avec succès',

  //ol center program activities table ----------------------------------------------------------------
  'ol.center.program.activities.table.title': 'Activités',
  'ol.center.program.activities.table.name': 'Nom',
  'ol.center.program.activities.table.number.of.students': '# Jeunes',
  'ol.center.program.activities.table.number.of.leaders': '# Encadrants',
  'ol.center.program.activities.table.local.transport': 'Mode de transport',
  'ol.center.program.activities.table.average.cost.per.student': 'Coût moyen par jeune',
  'ol.center.program.activities.table.total.cost': 'Coût total (transport exclu)',
  'ol.center.program.activities.table.paid.by': 'Payé par',
  'ol.center.program.activities.table.programs': 'Programmes',
  'ol.center.program.activities.table.option': 'Option',
  'ol.center.program.activities.table.total.activity.cost': 'Total activity cost',
  'ol.center.program.activities.table.part.paid.by.local.organizer':
    'Coût payé par l’organisateur local',
  'ol.center.program.activities.table.part.paid.by.french.leader': 'A Payer par le French Leader',

  //ol center local transport table ----------------------------------------------------------------
  'ol.center.local.transport.table.title': 'Transports locaux',
  'ol.center.local.transport.table.split.age': 'Âge de séparation',
  'ol.center.local.transport.table.price': 'Prix',
  'ol.center.local.transport.table.ftr.students': '# FTR Jeunes',
  'ol.center.local.transport.table.ftr.amount': 'Montant FTR',
  'ol.center.local.transport.table.french.leaders': 'Encadrants',
  'ol.center.local.transport.table.french.leaders.amount': 'Montant Encadrants',
  'ol.center.local.transport.table.total.cost': 'Coût total',
  'ol.center.local.transport.table.extra.transport.cost.for.ftr.students':
    'Coût transport supplémentaire pour FTR jeunes',
  'ol.center.local.transport.table.extra.transport.cost.for.leaders':
    'Coût transport supplémentaire pour encadrants',
  'ol.center.local.transport.table.total.local.transport.ftr.students.leaders':
    'Coût total transport FTR jeunes et encadrants',
  'ol.center.local.transport.table.part.paid.by.french.leader': 'A Payer par le French Leader',
  'ol.center.local.transport.table.part.paid.by.local.organizer':
    'Part payée par l’organisateur local',

  //ol center admin and grand expenses ----------------------------------------------------------------
  'ol.center.admin.expenses.title': 'Dépenses administratives',
  'ol.center.admin.expenses.total': 'Total',
  'ol.center.admin.expenses.paid.by.french.leader': 'A Payer par le French Leader',
  'ol.center.admin.expenses.paid.by.local.organizer': 'Part payée par l’organisateur local',
  'ol.center.grand.expenses.title': 'Dépenses générales',
  'ol.center.grand.expenses.total': 'Total',
  'ol.center.grand.expenses.paid.by.french.leader': 'A Payer par le French Leader',
  'ol.center.grand.expenses.paid.by.local.organizer': 'Part payée par l’organisateur local',

  //ol center Tefl Table ----------------------------------------------------------------
  'ol-center.tefl.table.badge.text': 'TEFL à affecter',
  'ol.center.tefl.table.lastName': 'Nom',
  'ol.center.tefl.table.firstName': 'Prénom',
  'ol.center.tefl.table.qualification': 'Qualification',
  'ol.center.tefl.table.age': 'Âge',
  'ol.center.tefl.table.gender': 'Sexe',

  //ol center Teaching hall badge ----------------------------------------------------------------
  'ol.center.teaching.hall.badge.text': 'Salle de cours à affecter',

  //center filters ----------------------------------------------------------------
  'center.filters.country': 'Pays',
  'center.filters.periods': 'Période(s)',
  'center.filters.formula': 'Formule(s)',

  //hobbies ----------------------------------------------------------------
  'hobbies.title': "Loisirs, centres d'intérêt",
  'hobbies.input.title': 'Loisirs',
  'hobbies.input.other': 'Autre',

  //image card -------------------------------------------------------------------
  'image.card.caption.label': 'Légende (dans la langue du pays de séjour)',
  'image.card.upload.label': 'Télécharger la photo *',
  'image.card.drag.label': 'Glisser-déposer ou parcourir',

  //host family images ----------------------------------------------------------------
  'host.family.images.note':
    "Elles doivent être agréables : n'oubliez pas que c'est le premier contact que la famille aura avec le participant, et qu'elles doivent le montrer sous un aspect sympathique. Joignez des photos de votre famille, au salon ou au jardin, lors d’un anniversaire, de vacances, etc. Merci d’indiquer une légende pour chacune des photos (dans la langue du pays de séjour).",

  //affected staff questionnaire ----------------------------------------------------------------
  'affected.staff.questionnaire.title': 'Questionnaire Complémentaire',
  'affected.staff.questionnaire.information.1':
    'Ce dossier complémentaire est à compléter rapidement et avec le plus de précisions possibles. Tant que vous n’aurez pas complété tous les champs et cliqué sur « ',
  'affected.staff.questionnaire.information.2': 'Valider et envoyer à LEC ',
  'affected.staff.questionnaire.information.3':
    '», il ne nous sera pas possible de sélectionner votre famille-hôtesse.',

  'affected.staff.questionnaire.personality.title': 'Personnalité',
  'affected.staff.questionnaire.personality.closer.to': 'Vous êtes plutôt :',
  'affected.staff.questionnaire.personality.have.religious.affiliation.question':
    'Avez-vous une appartenance religieuse que vous souhaitez mentionner ?',
  'affected.staff.questionnaire.which.one': 'Laquelle ?',
  'affected.staff.questionnaire.personality.interest': 'Vous aimez :',
  'affected.staff.questionnaire.personality.accept.living.with.family.of.different.ethnic.background.question':
    "Acceptez-vous d'être reçu(e) dans une famille d'origine ethnique différente ?",

  'affected.staff.questionnaire.health.information.title': 'Information Santé',
  'affected.staff.questionnaire.health.information.are.you.in.good.health':
    'Etes-vous en bonne santé?',
  'affected.staff.questionnaire.health.information.do.you.have.asthma':
    "Etes-vous sujet à l'asthme?",
  'affected.staff.questionnaire.health.information.do.you.have.allergy':
    'Avez-vous des allergies ?',
  'affected.staff.questionnaire.health.information.do.you.smoke': 'Est-ce que vous fumez ?',
  'affected.staff.questionnaire.health.information.agree.to.family.lifestyle':
    'J’ accepte de me conformer au mode de vie de la famille et de ne pas fumer devant les jeunes du groupe',
  'affected.staff.questionnaire.health.information.other.information':
    'Autres informations (en anglais)',
  'affected.staff.questionnaire.health.information.other.information.placeholder':
    'Autres informations ',
  'affected.staff.questionnaire.health.information.health.note':
    "Merci de noter que LEC ne peut garantir que les régimes alimentaires ou allergies des membres de l'encadrement soient prises en compte durant les séjours",

  'affected.staff.questionnaire.driver.license.title': 'Permis de conduire',
  'affected.staff.questionnaire.driver.license.do.you.have.driver.license':
    'Avez-vous votre permis de conduire?',
  'affected.staff.questionnaire.driver.license.do.you.drive.regularly':
    'Conduisez-vous régulièrement?',
  'affected.staff.questionnaire.driver.license.note':
    'Pensez à faire votre demande de permis de conduire international dès à présent',

  'affected.staff.questionnaire.host.family.letter': 'Lettre à votre famille-hôtesse',
  'affected.staff.questionnaire.host.family.letter.note':
    'Cette lettre doit impérativement être rédigée en anglais. N’oubliez pas qu’elle sera votre tout premier contact avec votre famille-hôtesse. Veillez ainsi à bien détailler vos centres d’intérêts, les sports que vous pratiquez, etc. Décrivez votre famille, précisez si vous avez des enfants, leurs âges. Parlez de votre environnement, où vous habitez, la région où vous vivez, etc.Expliquez les raisons pour lesquelles vous souhaitez effectuer ce séjour.',
  'affected.staff.questionnaire.host.family.letter.placeholder': 'Rédigez votre lettre ici',

  'affected.staff.questionnaire.host.family.pictures.title': 'Quelques photos de votre famille',
  'affected.staff.questionnaire.host.family.pictures.note.1': 'Merci de télécharger :',
  'affected.staff.questionnaire.host.family.pictures.note.2':
    "Au moins 3 photos récentes du type de celles que l'on trouve dans un album de famille. ",
  'affected.staff.questionnaire.host.family.pictures.note.3':
    "Elles doivent être agréables : n'oubliez pas que c'est le premier contact que la famille aura avec vous, et qu'elles doivent vous montrer sous un aspect sympathique. Joignez des photos de votre famille, au salon ou au jardin, lors d’un anniversaire, de vacances, etc. Merci d’indiquer une légende pour chacune des photos (en anglais).",
  'affected.staff.questionnaire.host.family.pictures.note.nb': 'NB : ',
  'affected.staff.questionnaire.host.family.pictures.note.nb.text':
    "Utilisez des images JPG ou PNG, d'une taille inférieure à 2 Mo",
  'affected.staff.questionnaire.host.family.pictures.upload.label.btn': 'Ajouter des photos',

  'affected.staff.questionnaire.medical.release': 'Décharge médicale',
  'affected.staff.questionnaire.medical.release.note.1': 'Je soussigné, ',
  'affected.staff.questionnaire.medical.release.note.2':
    'autorise LEC, 89 avenue de Villiers à Paris 75017, ainsi que ses collaborateurs et représentants français et étrangers (et la famille d’accueil) à agir en mon nom en cas d’urgence (maladie, accident, opération chirurgicale, - y compris anesthésie -, hospitalisation) pendant la durée de mon séjour à l’étranger. Cette décharge sera présentée au médecin, dentiste, chirurgien ou docteur d’hôpital le cas échéant.',
  'affected.staff.questionnaire.medical.release.checkbox.label': 'Je donne mon autorisation',

  'client.child.profile.medical.release.title': 'Décharge médicale',
  'client.child.profile.medical.release.long.text':
    "Je soussigné, père, mère ou tuteur de {{childFirstName}} {{childLastName}}, autorise LEC, 89 avenue de Villiers à Paris 75017, ainsi que ses collaborateurs et représentants français et étrangers (et la famille d'accueil) à agir en mon nom en cas d'urgence (maladie, accident, opération chirurgicale, - y compris anesthésie -, hospitalisation) pendant la durée de son séjour à l'étranger. Cette décharge sera présentée au médecin, dentiste, chirurgien ou directeur d'hôpital le cas échéant.",
  'client.child.profile.medical.release.short.text':
    'Les parents ou le tuteur légal donnent l’autorisation à LEC en cas d’urgence de prendre toutes dispositions pour hospitaliser leur enfant et l’opérer (y compris anesthésie) si cela s’avérait nécessaire.',
  'client.child.profile.medical.release.checkbox.label':
    'Je donne mon autorisation (parent, tuteur)',

  'client.child.profile.terms.checkbox.label': 'J’ai lu et j’accepte les',
  'client.child.profile.terms.link': 'conditions générales de vente',
  'client.child.profile.terms.accepted.label': 'Vous avez accepté les',
  'client.child.profile.terms.required': 'Vous devez accepter les conditions générales de vente',

  'staff.personal.space.save.for.later.btn': 'Enregistrer et continuer plus tard',
  'staff.personal.space.submit.btn': 'Valider et envoyer à LEC',

  'affected.staff.questionnaire.drives.regularly': 'Conduit régulièrement',

  'staff.personal.space.yes': 'Oui',
  'staff.personal.space.no': 'Non',

  'questionnaire.toast.success': 'Questionnaire soumis avec succès',
  'questionnaire.toast.error.familyImages':
    'Veuillez fournir des images de famille valides avec légende',
  'questionnaire.toast.error.familyImagesMinimum': 'Veuillez fournir au moins 3 images de famille',

  //large image error -----------------------------------------------------
  'images.size.error': 'Le fichier ne doit pas dépasser',
  'images.aspect.ratio.error': "Veuillez télécharger une image avec un rapport d'aspect de",
  'images.read.error': 'Impossible de lire le fichier',

  //logout ----------------------------------------------------------------
  logout: 'Déconnexion',

  //staff personal space details trip card --------------------------------
  'staff.personal.space.details.trip.card.aller': 'Voyage aller',
  'staff.personal.space.details.trip.card.retour': 'Voyage retour',
  'staff.personal.space.details.trip.card.date.of.departure': 'Date de départ',
  'staff.personal.space.details.trip.card.date.of.return': "Date d'arrivée",
  'staff.personal.space.details.trip.card.meeting.place': 'Lieu de RDV Encadrant',
  'staff.personal.space.details.trip.card.place.of.arrival': "Lieu d'arrivée",
  'staff.personal.space.details.trip.card.appointment.time': 'Heure de RDV Encadrant',
  'staff.personal.space.details.trip.card.time.of.arrival': "Heure d'arrivée",

  //editable table -------------------------------------------------------------
  'editable.table.max.value.error': 'La valeur ne doit pas dépasser',
  'editable.table.min.value.error': 'La valeur doit être au moins',
  'editable.table.select.none': 'Aucune',

  //magic link -------------------------------------------------------------
  'magic.link.check.inbox': 'Vérifiez votre boîte de réception',
  'magic.link.text': 'Vous devriez recevoir un e-mail avec un lien magique pour vous connecter.',

  //oto individual places -------------------------------------------------------------
  'oto.individual.title': 'Liste des OTO Indiv',
  'oto.individual.periods.table.title': 'Tous les OTO Indiv',
  'oto.individual.periods.placement.info':
    'Total de jeunes : {{total}} (Placés : {{placed}} – Non placés : {{unplaced}})',
  'oto.individual.periods.column.period': 'Periods',
  'oto.individual.periods.column.students.placed': '# de jeunes affectés',
  'oto.individual.periods.column.students.unplaced': 'Nb de jeunes non placés',
  'oto.individual.periods.column.students.affected': '# de jeunes affectés',
  'oto.individual.periods.column.students.to.diffuse': '# de jeunes à diffuser au presta',
  'oto.individual.periods.column.students.diffused': '# de jeunes déjà diffusés au presta',
  'oto.individual.periods.column.client.info.diffusion': 'Diffusion des infos aux clients',
  'oto.individual.periods.info.some.not.sent': 'Certaines infos non envoyées',
  'oto.individual.periods.info.no.placements': 'Aucun jeune placé pour le moment',
  'oto.individual.periods.info.all.sent': 'Toutes les infos envoyées',
  'oto.individual.periods.actions.diffuse.to.ol': 'Diffusion jeunes au Presta',
  'oto.individual.periods.actions.diffuse.to.ol.confirm':
    'Les jeunes des périodes sélectionnées seront diffusés au prestataire. Voulez-vous continuer ?',
  'oto.individual.periods.diffuse.to.ol.success':
    'La diffusion des jeunes au prestataire a bien été effectuée.',

  'oto.individual.placements.title': 'OTO Individuels - Liste des jeunes',
  'oto.individual.placements.period.label': 'Période :',
  'oto.individual.placements.table.title': 'Jeunes de la période',
  'oto.individual.placements.column.student.placed': 'Jeune placé',
  'oto.individual.placements.column.last.name': 'Nom du jeune',
  'oto.individual.placements.column.first.name': 'Prénom du jeune',
  'oto.individual.placements.column.dates.of.stay': 'Dates de séjour',
  'oto.individual.placements.column.weeks': 'Nombre de semaines',
  'oto.individual.placements.column.age': 'Âge',
  'oto.individual.placements.column.school.level': 'Classe',
  'oto.individual.placements.column.sex': 'Sexe',
  'oto.individual.placements.column.health': 'Santé',
  'oto.individual.placements.column.hours.per.week': '#heures cours/sem',
  'oto.individual.placements.column.option': 'Option',
  'oto.individual.placements.column.arrival.location': "Lieu d'arrivée",
  'oto.individual.placements.column.area.of.stay': 'Région de séjour',
  'oto.individual.placements.column.transfer.welcome': 'Accueil transfert',
  'oto.individual.placements.column.travel.info': 'Travel info',
  'oto.individual.placements.column.host.family': 'Famille-hôtesse',
  'oto.individual.placements.column.hf.info.sent.to.parents':
    'Infos FA diffusées par LEC aux parents',
  'oto.individual.placements.column.parents.diffusion.status': 'Statut diffusion aux parents',
  'oto.individual.placements.column.last.parents.diffusion.date':
    'Date dernière diffusion aux parents',
  'oto.individual.placements.column.diffused.to.ol': 'Date de diffusion du jeune au presta',
  'oto.individual.placements.host.family.info.emailed':
    "Les informations ont été envoyées par email à la famille d'accueil",
  'oto.individual.placements.host.family.assign': "Affecter une famille d'accueil",
  'oto.individual.placements.host.family.change': "Changer la famille d'accueil",
  'oto.individual.placements.host.family.assigned': "La famille d'accueil a bien été affectée !",
  'oto.individual.placements.host.family.changed': "La famille d'accueil a bien été changée !",
  'oto.individual.placements.host.family.unassigned': "La famille d'accueil a bien été retirée !",
  'oto.individual.placements.removed': '(Retiré)',
  'oto.individual.placements.acknowledgement': 'Accusé de réception',
  'oto.individual.placements.removal.acknowledged':
    'Le retrait du jeune a bien été pris en compte !',
  'oto.individual.placements.transfer.welcome.yes': 'Oui',
  'oto.individual.placements.filter.country': 'Pays',
  'oto.individual.placements.filter.departure.date': 'Date de départ',
  'oto.individual.placements.filter.arrival.date': 'Date d’arrivée',
  'oto.individual.placements.period.invalid': 'Identifiant de période invalide',
  'oto.individual.placements.period.not.found': 'Période introuvable',
  'oto.individual.placements.info.not.fully.sent.to.parents':
    "Les infos FA n'ont pas encore été entièrement diffusées aux parents",
  'oto.individual.placements.actions.diffuse.info.to.parents': 'Diffusion info aux parents',
  'oto.individual.placements.actions.send.host.family.info':
    "Envoyer les infos de la famille d'accueil à la famille",
  'oto.individual.placements.actions.print.transfers.list':
    'Imprimer la liste des jeunes & transferts',
  'oto.individual.placements.info.sent.success':
    "Les informations de la famille d'accueil ont bien été envoyées aux familles.",
  'oto.individual.placements.enrollments.info.sent.success':
    "Les informations des jeunes ont bien été envoyées aux familles d'accueil.",
  'oto.individual.placements.actions.diffuse.end.of.stay.appreciations':
    'Diffuser les appréciations de fin de séjour',
  'oto.individual.placements.end.of.stay.appreciations.diffused.success':
    'Les appréciations de fin de séjour ont bien été diffusées au prestataire.',
  'oto.individual.placements.transfer.person.title': 'Personne en charge des transferts',
  'oto.individual.placements.transfer.person.last.name': 'Nom',
  'oto.individual.placements.transfer.person.first.name': 'Prénom',
  'oto.individual.placements.transfer.person.phone.number': 'Numéro de téléphone',
  'oto.individual.placements.transfer.person.email': 'Email',
  'oto.individual.placements.transfer.person.updated.success':
    'La personne en charge du transfert a bien été enregistrée.',
  'oto.individual.placements.transfer.person.missing': 'Personne en charge manquante',
  'oto.individual.placements.transfer.person.completed': 'Complété',
  'oto.individual.placements.travel.info.not.available': 'Pas encore disponible',

  // affected staff evaluations -------------------------------------------------------------
  'affected.staff.evaluations.lec.rating': 'Note LEC',
  'affected.staff.evaluations.comment': 'Commentaire',
  'affected.staff.evaluations.youths.rating': 'Note moyenne des jeunes',
  'affected.staff.evaluations.youths.rating.answers': '{{answers}} réponse(s)',
  'affected.staff.evaluations.youths.rating.not.rated': 'Non noté pour cette qualification',
  'affected.staff.evaluations.youths.rating.error': 'Une erreur est survenue',

  // end of stay appreciations -------------------------------------------------------------
  'enrollment.end.of.stay.appreciations.all.questions': 'Toutes les questions',
  'enrollment.end.of.stay.appreciations.no.stay': 'Aucun séjour',

  'end.of.stay.appreciations.summary.page.title': 'Appréciations',
  'end.of.stay.appreciations.summary.table.title': 'Toutes les appréciations',
  'end.of.stay.appreciations.summary.total': 'Total : {{total}}',
  'end.of.stay.appreciations.summary.print': 'Imprimer',
  'end.of.stay.appreciations.summary.print.loading': 'Chargement…',
  'end.of.stay.appreciations.summary.print.blocked':
    "La fenêtre d'impression a été bloquée par le navigateur.",
  'end.of.stay.appreciations.summary.export': 'Export excel',
  'end.of.stay.appreciations.summary.filter': 'Filtrer par',
  'end.of.stay.appreciations.summary.filter.country': 'Pays',
  'end.of.stay.appreciations.summary.filter.formula': 'Formule',
  'end.of.stay.appreciations.summary.filter.theme': 'Thème',
  'end.of.stay.appreciations.summary.filter.ol': 'Prestataire',
  'end.of.stay.appreciations.summary.filter.periods': 'Périodes',
  'end.of.stay.appreciations.summary.filter.year': 'Année',
  'end.of.stay.appreciations.summary.filter.include.oto': 'Inclure OTO',
  'end.of.stay.appreciations.summary.filter.five.stars': 'Notes sur 5',
  'end.of.stay.appreciations.summary.filter.three.stars': 'Notes sur 3',
  'end.of.stay.appreciations.summary.filter.star': '{{stars}} étoile',
  'end.of.stay.appreciations.summary.filter.stars': '{{stars}} étoiles',
  'end.of.stay.appreciations.summary.filter.scan.status.all': 'Tout',
  'end.of.stay.appreciations.summary.filter.scan.status.not.scanned': 'Centres non scannés',
  'end.of.stay.appreciations.summary.filter.scan.status.incomplete': 'Centres incomplets',
  'end.of.stay.appreciations.summary.columns.country': 'Pays',
  'end.of.stay.appreciations.summary.columns.centre': 'Centre',
  'end.of.stay.appreciations.summary.columns.enrolled': 'insc.',
  'end.of.stay.appreciations.summary.sort.asc': 'Tri croissant',
  'end.of.stay.appreciations.summary.sort.desc': 'Tri décroissant',
  'end.of.stay.appreciations.summary.general.total': 'TOTAL GÉNÉRAL',
  'end.of.stay.appreciations.summary.rows.answers': 'Total de réponses',
  'end.of.stay.appreciations.summary.rows.response.rate': 'Taux de réponses (%)',
  'end.of.stay.appreciations.summary.rows.average': 'Moyenne',
  'end.of.stay.appreciations.summary.rows.enrolled.and.average': 'Total inscrits et moyenne',

  // end of journey scans -------------------------------------------------------------
  'end.of.journey.scans.status.to.process': 'À traiter',
  'end.of.journey.scans.status.processing': 'En cours',
  'end.of.journey.scans.status.processed': 'Traité',
  'end.of.journey.scans.status.failed': 'Échec',
  'end.of.journey.scans.failure.unreadable': 'Illisible',
  'end.of.journey.scans.failure.unidentified': 'Jeune non identifié',
  'end.of.journey.scans.failure.enrollment.not.found': 'Jeune introuvable',
  'end.of.journey.scans.failure.ambiguous.enrollment': 'Plusieurs jeunes possibles',
  'end.of.journey.scans.failure.identity.mismatch': 'Identité incohérente',
  'end.of.journey.scans.failure.template.not.found': 'Template introuvable',
  'end.of.journey.scans.failure.already.received': 'Déjà reçu',
  'end.of.journey.scans.failure.invalid.answers': 'Réponses invalides',
  'end.of.journey.scans.failure.extraction.error': 'Erreur de lecture',
  'end.of.journey.scans.page.title': 'Traitement des questionnaires',
  'end.of.journey.scans.page.upload.title': 'Envoyer des questionnaires scannés',
  'end.of.journey.scans.page.list.title': 'Questionnaires',
  'end.of.journey.scans.reading.paused.no.api.key':
    'La lecture est en pause : les questionnaires envoyés restent en attente et seront traités dès que la clé de lecture sera configurée.',
  'end.of.journey.scans.reading.paused.key.rejected':
    'La lecture est en pause : les questionnaires envoyés restent en attente et seront traités dès que la clé de lecture refusée par le service aura été remplacée.',
  'end.of.journey.scans.reading.paused.no.credit':
    'La lecture est en pause : les questionnaires envoyés restent en attente et seront traités dès que le crédit du service de lecture aura été rechargé.',
  'end.of.journey.scans.reading.paused.rate.limited':
    "La lecture est en pause (limite d'utilisation du service de lecture atteinte) : les questionnaires envoyés restent en attente et seront traités dès que le service de lecture sera de nouveau disponible.",
  'end.of.journey.scans.reading.paused.overloaded':
    'La lecture est en pause (service de lecture surchargé) : les questionnaires envoyés restent en attente et seront traités dès que le service de lecture sera de nouveau disponible.',
  'end.of.journey.scans.reading.paused.no.template':
    "La lecture est en pause : les questionnaires envoyés restent en attente et seront traités dès qu'un modèle de questionnaire avec des questions existera.",
  'end.of.journey.scans.reading.paused.since': 'En pause depuis le {{date}}.',
  'end.of.journey.scans.reading.paused.resumes.automatically':
    'Le traitement reprendra automatiquement.',
  'end.of.journey.scans.upload.help':
    "Un PDF par questionnaire. Choisissez les fichiers ou déposez-les, ou leur dossier, ci-dessous. Chaque questionnaire est rattaché au jeune grâce à son QR code (à défaut, le n° d'inscription écrit sur la copie).",
  'end.of.journey.scans.upload.help.limits':
    "Un PDF par questionnaire ({{maxFiles}} PDF au plus par envoi, {{maxFileMb}} Mo au plus chacun). Choisissez les fichiers ou déposez-les, ou leur dossier, ci-dessous. Chaque questionnaire est rattaché au jeune grâce à son QR code (à défaut, le n° d'inscription écrit sur la copie).",
  'end.of.journey.scans.upload.drop.zone': 'Déposez les PDF ou leur dossier ici',
  'end.of.journey.scans.upload.choose.files': 'Choisir les PDF',
  'end.of.journey.scans.upload.ready': '{{number}} PDF prêt(s) à envoyer',
  'end.of.journey.scans.upload.progress': '{{done}} / {{total}} fichier(s) transféré(s)',
  'end.of.journey.scans.upload.error.not.pdf': "{{fileName}} : ce n'est pas un PDF",
  'end.of.journey.scans.upload.error.limits':
    "Les limites d'envoi n'ont pas pu être chargées, aucun fichier ne peut être choisi : {{message}}",
  'end.of.journey.scans.upload.error.too.large': '{{fileName}} : dépasse {{maxFileMb}} Mo',
  'end.of.journey.scans.upload.error.too.many':
    '{{number}} PDF choisis : {{maxFiles}} au plus par envoi, envoyez-les en plusieurs fois',
  'end.of.journey.scans.upload.error.failed': "{{fileName}} : l'envoi a échoué, renvoyez-le",
  'end.of.journey.scans.upload.success':
    '{{number}} questionnaire(s) envoyé(s) : ils vont être lus.',
  'end.of.journey.scans.upload.success.paused':
    "{{number}} questionnaire(s) reçu(s) : la lecture est en pause, ils restent en attente et seront traités dès qu'elle reprendra.",
  'end.of.journey.scans.upload.failed': "{{number}} fichier(s) n'ont pas pu être envoyés.",
  'end.of.journey.scans.send': 'Envoyer',
  'end.of.journey.scans.cancel': 'Annuler',
  'end.of.journey.scans.tab.all': 'Tous',
  'end.of.journey.scans.filter.retried': 'Plusieurs tentatives',
  'end.of.journey.scans.column.file': 'Fichier',
  'end.of.journey.scans.column.status': 'Statut',
  'end.of.journey.scans.column.youth': 'Jeune',
  'end.of.journey.scans.column.attempts': 'Tentatives',
  'end.of.journey.scans.column.ambiguous': 'Réponses incertaines',
  'end.of.journey.scans.column.sent.at': 'Envoyé le',
  'end.of.journey.scans.template.id': 'Template #{{id}}',
  'end.of.journey.scans.stuck': 'Bloqué en cours de traitement',
  'end.of.journey.scans.replace.existing': 'Remplacera le questionnaire reçu',
  'end.of.journey.scans.ambiguous.count': '{{number}} incertaine(s)',
  'end.of.journey.scans.blank.count': '{{number}} sans réponse',
  'end.of.journey.scans.uncertain.type.several.marked': 'plusieurs cases cochées',
  'end.of.journey.scans.uncertain.type.unclear.mark': 'marque peu lisible ou trop légère',
  'end.of.journey.scans.uncertain.type.erased': 'réponse effacée ou barrée',
  'end.of.journey.scans.uncertain.type.outside.boxes': 'marque en dehors des cases',
  'end.of.journey.scans.uncertain.type.other': 'autre',
  'end.of.journey.scans.no.results': 'Aucun questionnaire',
  'end.of.journey.scans.load.retry': 'Réessayer',
  'end.of.journey.scans.action.preview': 'Voir le scan',
  'end.of.journey.scans.action.reupload': 'Rescanner',
  'end.of.journey.scans.action.retry': 'Relancer',
  'end.of.journey.scans.action.replace': 'Remplacer',
  'end.of.journey.scans.action.manual': 'Saisie manuelle',
  'end.of.journey.scans.action.correct': 'Corriger',
  'end.of.journey.scans.preview.title': 'Scan',
  'end.of.journey.scans.preview.loading': 'Chargement...',
  'end.of.journey.scans.preview.unavailable':
    "Le scan n'est pas disponible : il est encore en cours d'analyse antivirus, ou il a été rejeté par l'antivirus.",
  'end.of.journey.scans.reupload.title': 'Rescanner le questionnaire',
  'end.of.journey.scans.reupload.help': 'Scannez de nouveau ce questionnaire seul, en un PDF.',
  'end.of.journey.scans.reupload.choose.file': 'Choisir le fichier',
  'end.of.journey.scans.reupload.error.not.pdf': "Le fichier n'est pas un PDF",
  'end.of.journey.scans.reupload.error.too.large': 'Le fichier dépasse {{maxFileMb}} Mo',
  'end.of.journey.scans.replace.title': 'Remplacer le questionnaire ?',
  'end.of.journey.scans.replace.subtitle':
    'Ce jeune a déjà un questionnaire enregistré. Le remplacer par cette saisie ?',
  'end.of.journey.scans.correct.title': 'Corriger le questionnaire',
  'end.of.journey.scans.correct.note':
    '{{number}} réponse(s) incertaine(s) ont été laissées vides : vérifiez-les sur le scan.',
  'end.of.journey.scans.correct.note.blank':
    '{{number}} question(s) sans réponse ont été laissées vides : vérifiez-les sur le scan.',
  'end.of.journey.scans.correct.note.both':
    '{{ambiguous}} réponse(s) incertaine(s) et {{blank}} question(s) sans réponse ont été laissées vides : vérifiez-les sur le scan.',
  'end.of.journey.scans.retry.confirm.title': 'Relancer la lecture ?',
  'end.of.journey.scans.retry.confirm.text':
    'Le questionnaire « {{fileName}} » sera envoyé à nouveau à la lecture automatique, avec un nouveau cycle de tentatives.',
  'end.of.journey.scans.retry.replace.confirm.title': 'Relancer la lecture et remplacer ?',
  'end.of.journey.scans.retry.replace.confirm.text':
    'Le questionnaire « {{fileName}} » sera envoyé à nouveau à la lecture automatique, avec un nouveau cycle de tentatives. Le questionnaire déjà reçu pour ce jeune sera remplacé.',
  'end.of.journey.scans.retry.success': 'Le questionnaire va être relancé.',
  'end.of.journey.scans.retry.success.paused':
    "Le questionnaire est remis en attente : la lecture est en pause, il sera traité dès qu'elle reprendra.",
  'end.of.journey.scans.reupload.success': 'Le nouveau scan va être traité.',
  'end.of.journey.scans.reupload.success.paused':
    "Le nouveau scan est reçu : la lecture est en pause, il sera traité dès qu'elle reprendra.",
  'end.of.journey.scans.resolve.success': 'Questionnaire enregistré.',
  'end.of.journey.scans.correct.success': 'Questionnaire corrigé.',
  'end.of.journey.questionnaire.youth': 'Jeune',
  'end.of.journey.questionnaire.not.answered': 'Non répondu',
  'end.of.journey.questionnaire.blank.on.copy': 'Sans réponse sur la copie',
  'end.of.journey.questionnaire.rating': '{{rating}} / {{scaleMax}}',
  'end.of.journey.questionnaire.already.received':
    'Ce jeune a déjà un questionnaire : il sera remplacé après confirmation.',
  'end.of.journey.questionnaire.no.template':
    "Aucun template de fin de séjour n'est associé au séjour de ce jeune.",
  'end.of.journey.questionnaire.cancel': 'Annuler',
  'end.of.journey.questionnaire.save': 'Enregistrer',

  // dynamic table toast messages -------------------------------------------------------------
  'dynamic.data.table.delete.success': 'Les éléments sélectionnés ont été supprimés avec succès.'
}
